module.exports = nativeDescription: "English (US)", englishDescription: "English (US)", translation:
#  new_home:
#    slogan: "The most engaging game for learning programming."
#    classroom_edition: "Classroom Edition:"
#    learn_to_code: "Learn to code:"
#    play_now: "Play Now"
#    im_a_teacher: "I'm a Teacher"
#    im_a_student: "I'm a Student"
#    learn_more: "Learn more"
#    classroom_in_a_box: "A classroom in-a-box for teaching computer science."
#    codecombat_is: "CodeCombat is a platform <strong>for students</strong> to learn computer science while playing through a real game."
#    our_courses: "Our courses have been specifically playtested <strong>to excel in the classroom</strong>, even by teachers with little to no prior programming experience."
#    top_screenshots_hint: "Students write code and see their changes update in real-time"
#    designed_with: "Designed with teachers in mind"
#    real_code: "Real, typed code"
#    from_the_first_level: "from the first level"
#    getting_students: "Getting students to typed code as quickly as possible is critical to learning programming syntax and proper structure."
#    educator_resources: "Educator resources"
#    course_guides: "and course guides"
#    teaching_computer_science: "Teaching computer science does not require a costly degree, because we provide tools to support educators of all backgrounds."
#    accessible_to: "Accessible to"
#    everyone: "everyone"
#    democratizing: "Democratizing the process of learning coding is at the core of our philosophy. Everyone should be able to learn to code."
#    forgot_learning: "I think they actually forgot that they were actually learning something."
#    wanted_to_do: " Coding is something I've always wanted to do, and I never thought I would be able to learn it in school."
#    why_games: "Why is learning through games important?"
#    games_reward: "Games reward the productive struggle."
#    encourage: "Gaming is a medium that encourages interaction, discovery, and trial-and-error. A good game challenges the player to master skills over time, which is the same critical process students go through as they learn."
#    excel: "Games excel at rewarding"
#    struggle: "productive struggle"
#    kind_of_struggle: "the kind of struggle that results in learning that’s engaging and"
#    motivating: "motivating"
#    not_tedious: "not tedious."
#    gaming_is_good: "Studies suggest gaming is good for children’s brains. (it’s true!)"
#    game_based: "When game-based learning systems are"
#    compared: "compared"
#    conventional: "against conventional assessment methods, the difference is clear: games are better at helping students retain knowledge, concentrate and"
#    perform_at_higher_level: "perform at a higher level of achievement"
#    feedback: "Games also provide real-time feedback that allows students to adjust their solution path and understand concepts more holistically, instead of being limited to just “correct” or “incorrect” answers."
#    real_game: "A real game, played with real coding."
#    great_game: "A great game is more than just badges and achievements - it’s about a player’s journey, well-designed puzzles, and the ability to tackle challenges with agency and confidence."
#    agency: "CodeCombat is a game that gives players that agency and confidence with our robust typed code engine, which helps beginner and advanced students alike write proper, valid code."
#    request_demo_title: "Get your students started today!"
#    request_demo_subtitle: "Request a demo and get your students started in less than an hour."
#    get_started_title: "Set up your class today"
#    get_started_subtitle: "Set up a class, add your students, and monitor their progress as they learn computer science."
#    request_demo: "Request a Demo"
#    setup_a_class: "Set Up a Class"
#    have_an_account: "Have an account?"
#    logged_in_as: "You are currently logged in as"
#    computer_science: "Computer science courses for all ages"
#    show_me_lesson_time: "Show me lesson time estimates for:"
#    curriculum: "Total curriculum hours:"
#    ffa: "Free for all students"
#    lesson_time: "Lesson time:"
#    coming_soon: "More coming soon!"
#    courses_available_in: "Courses are available in JavaScript and Python. Web Development courses utilize HTML, CSS, jQuery, and Bootstrap."
#    boast: "Boasts riddles that are complex enough to fascinate gamers and coders alike."
#    winning: "A winning combination of RPG gameplay and programming homework that pulls off making kid-friendly education legitimately enjoyable."
#    run_class: "Everything you need to run a computer science class in your school today, no CS background required."
#    goto_classes: "Go to My Classes"
#    view_profile: "View My Profile"
#    view_progress: "View Progress"
#    go_to_courses: "Go to My Courses"
#    want_coco: "Want CodeCombat at your school?"

#  nav:
#    play: "Levels" # The top nav bar entry where players choose which levels to play
#    community: "Community"
#    courses: "Courses"
#    blog: "Blog"
#    forum: "Forum"
#    account: "Account"
#    my_account: "My Account"
#    profile: "Profile"
#    home: "Home"
#    contribute: "Contribute"
#    legal: "Legal"
#    privacy: "Privacy"
#    about: "About"
#    contact: "Contact"
#    twitter_follow: "Follow"
#    my_classrooms: "My Classes"
#    my_courses: "My Courses"
#    careers: "Careers"
#    facebook: "Facebook"
#    twitter: "Twitter"
#    create_a_class: "Create a Class"
#    other: "Other"
#    learn_to_code: "Learn to Code!"
#    toggle_nav: "Toggle navigation"
#    jobs: "Jobs"
#    schools: "Schools"
#    get_involved: "Get Involved"
#    open_source: "Open source (GitHub)"
#    support: "Support"
#    faqs: "FAQs"
#    help_pref: "Need help? Email"
#    help_suff: "and we'll get in touch!"
#    resource_hub: "Resource Hub"

#  modal:
#    close: "Close"
#    okay: "Okay"

#  not_found:
#    page_not_found: "Page not found"

#  diplomat_suggestion:
#    title: "Help translate CodeCombat!" # This shows up when a player switches to a non-English language using the language selector.
#    sub_heading: "We need your language skills."
#    pitch_body: "We develop CodeCombat in English, but we already have players all over the world. Many of them want to play in {English} but don't speak English, so if you can speak both, please consider signing up to be a Diplomat and help translate both the CodeCombat website and all the levels into {English}."
#    missing_translations: "Until we can translate everything into {English}, you'll see English when {English} isn't available."
#    learn_more: "Learn more about being a Diplomat"
#    subscribe_as_diplomat: "Subscribe as a Diplomat"

#  play:
#    play_as: "Play As" # Ladder page
#    compete: "Compete!" # Course details page
#    spectate: "Spectate" # Ladder page
#    players: "players" # Hover over a level on /play
#    hours_played: "hours played" # Hover over a level on /play
#    items: "Items" # Tooltip on item shop button from /play
#    unlock: "Unlock" # For purchasing items and heroes
#    confirm: "Confirm"
#    owned: "Owned" # For items you own
#    locked: "Locked"
#    purchasable: "Purchasable" # For a hero you unlocked but haven't purchased
#    available: "Available"
#    skills_granted: "Skills Granted" # Property documentation details
#    heroes: "Heroes" # Tooltip on hero shop button from /play
#    achievements: "Achievements" # Tooltip on achievement list button from /play
#    settings: "Settings" # Tooltip on settings button from /play
#    poll: "Poll" # Tooltip on poll button from /play
#    next: "Next" # Go from choose hero to choose inventory before playing a level
#    change_hero: "Change Hero" # Go back from choose inventory to choose hero
#    buy_gems: "Buy Gems"
#    subscription_required: "Subscription Required"
#    subscribers_only: "Subscribers Only!"
#    subscribe_unlock: "Subscribe to Unlock!"
#    subscriber_heroes: "Subscribe today to immediately unlock Amara, Hushbaum, and Hattori!"
#    subscriber_gems: "Subscribe today to purchase this hero with gems!"
#    anonymous: "Anonymous Player"
#    level_difficulty: "Difficulty: "
#    play_classroom_version: "Play Classroom Version" # Choose a level in campaign version that you also can play in one of your courses
#    campaign_beginner: "Beginner Campaign"
#    awaiting_levels_adventurer_prefix: "We release new levels every week."
#    awaiting_levels_adventurer: "Sign up as an Adventurer"
#    awaiting_levels_adventurer_suffix: "to be the first to play new levels."
#    adjust_volume: "Adjust volume"
#    campaign_multiplayer: "Multiplayer Arenas"
#    campaign_multiplayer_description: "... in which you code head-to-head against other players."
#    brain_pop_done: "You’ve defeated the Ogres with code! You win!"
#    brain_pop_challenge: "Challenge yourself to play again using a different programming language!"
#    replay: "Replay"
#    back_to_classroom: "Back to Classroom"

#  code:
#    if: "if" # Keywords--these translations show up on hover, so please translate them all, even if it's kind of long. (In the code editor, they will still be in English.)
#    else: "else"
#    elif: "else if"
#    while: "while"
#    loop: "loop"
#    for: "for"
#    break: "break"
#    continue: "continue"
#    pass: "pass"
#    return: "return"
#    then: "then"
#    do: "do"
#    end: "end"
#    function: "function"
#    def: "define"
#    var: "variable"
#    self: "self"
#    hero: "hero"
#    this: "this"
#    or: "or"
#    "||": "or"
#    and: "and"
#    "&&": "and"
#    not: "not"
#    "!": "not"
#    "=": "assign"
#    "==": "equals"
#    "===": "strictly equals"
#    "!=": "does not equal"
#    "!==": "does not strictly equal"
#    ">": "is greater than"
#    ">=": "is greater than or equal"
#    "<": "is less than"
#    "<=": "is less than or equal"
#    "*": "multiplied by"
#    "/": "divided by"
#    "+": "plus"
#    "-": "minus"
#    "+=": "add and assign"
#    "-=": "subtract and assign"
#    True: "True"
#    true: "true"
#    False: "False"
#    false: "false"
#    undefined: "undefined"
#    null: "null"
#    nil: "nil"
#    None: "None"

#  share_progress_modal:
#    blurb: "You’re making great progress! Tell your parent how much you've learned with CodeCombat."
#    email_invalid: "Email address invalid."
#    form_blurb: "Enter your parent's email below and we’ll show them!"
#    form_label: "Email Address"
#    placeholder: "email address"
#    title: "Excellent Work, Apprentice"

#  login:
#    sign_up: "Create Account"
#    email_or_username: "Email or username"
#    log_in: "Log In"
#    logging_in: "Logging In"
#    log_out: "Log Out"
#    forgot_password: "Forgot your password?"
#    authenticate_gplus: "Authenticate Google"
#    load_profile: "Load Google Profile"
#    finishing: "Finishing"
#    sign_in_with_facebook: "Sign in with Facebook"
#    sign_in_with_gplus: "Sign in with Google"
#    signup_switch: "Want to create an account?"

#  signup:
#    create_student_header: "Create Student Account"
#    create_teacher_header: "Create Teacher Account"
#    create_individual_header: "Create Individual Account"
#    email_announcements: "Receive announcements about new CodeCombat levels and features!"
#    creating: "Creating Account..."
#    sign_up: "Sign Up"
#    log_in: "log in with password"
#    required: "You need to log in before you can go that way."
#    login_switch: "Already have an account?"
#    school_name: "School Name and City"
#    optional: "optional"
#    school_name_placeholder: "Example High School, Springfield, IL"
#    connected_gplus_header: "You've successfully connected with Google+!"
#    connected_gplus_p: "Finish signing up so you can log in with your Google+ account."
#    gplus_exists: "You already have an account associated with Google+!"
#    connected_facebook_header: "You've successfully connected with Facebook!"
#    connected_facebook_p: "Finish signing up so you can log in with your Facebook account."
#    facebook_exists: "You already have an account associated with Facebook!"
#    hey_students: "Students, enter the class code from your teacher."
#    birthday: "Birthday"
#    parent_email_blurb: "We know you can't wait to learn programming &mdash; we're excited too! Your parents will receive an email with further instructions on how to create an account for you. Email {{email_link}} if you have any questions."
#    classroom_not_found: "No classes exist with this Class Code. Check your spelling or ask your teacher for help."
#    checking: "Checking..."
#    account_exists: "This email is already in use:"
#    sign_in: "Sign in"
#    email_good: "Email looks good!"
#    name_taken: "Username already taken! Try {{suggestedName}}?"
#    name_available: "Username available!"
#    name_is_email: "Username may not be an email"
#    choose_type: "Choose your account type:"
#    teacher_type_1: "Teach programming using CodeCombat!"
#    teacher_type_2: "Set up your class"
#    teacher_type_3: "Access Course Guides"
#    teacher_type_4: "View student progress"
#    signup_as_teacher: "Sign up as a Teacher"
#    student_type_1: "Learn to program while playing an engaging game!"
#    student_type_2: "Play with your class"
#    student_type_3: "Compete in arenas"
#    student_type_4: "Choose your hero!"
#    student_type_5: "Have your Class Code ready!"
#    signup_as_student: "Sign up as a Student"
#    individuals_or_parents: "Individuals & Parents"
#    individual_type: "For players learning to code outside of a class. Parents should sign up for an account here."
#    signup_as_individual: "Sign up as an Individual"
#    enter_class_code: "Enter your Class Code"
#    enter_birthdate: "Enter your birthdate:"
#    parent_use_birthdate: "Parents, use your own birthdate."
#    ask_teacher_1: "Ask your teacher for your Class Code."
#    ask_teacher_2: "Not part of a class? Create an "
#    ask_teacher_3: "Individual Account"
#    ask_teacher_4: " instead."
#    about_to_join: "You're about to join:"
#    enter_parent_email: "Enter your parent’s email address:"
#    parent_email_error: "Something went wrong when trying to send the email. Check the email address and try again."
#    parent_email_sent: "We’ve sent an email with further instructions on how to create an account. Ask your parent to check their inbox."
#    account_created: "Account Created!"
#    confirm_student_blurb: "Write down your information so that you don't forget it. Your teacher can also help you reset your password at any time."
#    confirm_individual_blurb: "Write down your login information in case you need it later. Verify your email so you can recover your account if you ever forget your password - check your inbox!"
#    write_this_down: "Write this down:"
#    start_playing: "Start Playing!"
#    sso_connected: "Successfully connected with:"
#    select_your_starting_hero: "Select Your Starting Hero:"
#    you_can_always_change_your_hero_later: "You can always change your hero later."
#    finish: "Finish"
#    teacher_ready_to_create_class: "You're ready to create your first class!"
#    teacher_students_can_start_now: "Your students will be able to start playing the first course, Introduction to Computer Science, immediately."
#    teacher_list_create_class: "On the next screen you will be able to create a new class."
#    teacher_list_add_students: "Add students to the class by clicking the View Class link, then sending your students the Class Code or URL. You can also invite them via email if they have email addresses."
#    teacher_list_resource_hub_1: "Check out the"
#    teacher_list_resource_hub_2: "Course Guides"
#    teacher_list_resource_hub_3: "for solutions to every level, and the"
#    teacher_list_resource_hub_4: "Resource Hub"
#    teacher_list_resource_hub_5: "for curriculum guides, activities, and more!"
#    teacher_additional_questions: "That’s it! If you need additional help or have questions, reach out to __supportEmail__."
#    dont_use_our_email_silly: "Don't put our email here! Put your parent's email."

#  recover:
#    recover_account_title: "Recover Account"
#    send_password: "Send Recovery Password"
#    recovery_sent: "Recovery email sent."

#  items:
#    primary: "Primary"
#    secondary: "Secondary"
#    armor: "Armor"
#    accessories: "Accessories"
#    misc: "Misc"
#    books: "Books"

  common:
#    back: "Back" # When used as an action verb, like "Navigate backward"
#    coming_soon: "Coming soon!"
#    continue: "Continue" # When used as an action verb, like "Continue forward"
#    next: "Next"
#    default_code: "Default Code"
    loading: "Loading..."
#    overview: "Overview"
#    solution: "Solution"
#    intro: "Intro"
#    saving: "Saving..."
#    sending: "Sending..."
#    send: "Send"
#    sent: "Sent"
#    cancel: "Cancel"
#    save: "Save"
#    publish: "Publish"
#    create: "Create"
#    fork: "Fork"
#    play: "Play" # When used as an action verb, like "Play next level"
#    retry: "Retry"
#    actions: "Actions"
#    info: "Info"
#    help: "Help"
#    watch: "Watch"
#    unwatch: "Unwatch"
#    submit_patch: "Submit Patch"
#    submit_changes: "Submit Changes"
#    save_changes: "Save Changes"
#    required_field: "required"
#    valid_phone: "Enter a valid phone number."

#  general:
#    and: "and"
#    name: "Name"
#    date: "Date"
#    body: "Body"
#    version: "Version"
#    pending: "Pending"
#    accepted: "Accepted"
#    rejected: "Rejected"
#    withdrawn: "Withdrawn"
#    accept: "Accept"
#    reject: "Reject"
#    withdraw: "Withdraw"
#    submitter: "Submitter"
#    submitted: "Submitted"
#    commit_msg: "Commit Message"
#    version_history: "Version History"
#    version_history_for: "Version History for: "
#    select_changes: "Select two changes below to see the difference."
#    undo_prefix: "Undo"
#    undo_shortcut: "(Ctrl+Z)"
#    redo_prefix: "Redo"
#    redo_shortcut: "(Ctrl+Shift+Z)"
#    play_preview: "Play preview of current level"
#    result: "Result"
#    results: "Results"
#    description: "Description"
#    or: "or"
#    subject: "Subject"
#    email: "Email"
#    password: "Password"
#    confirm_password: "Confirm Password"
#    message: "Message"
#    code: "Code"
#    ladder: "Ladder"
#    when: "When"
#    opponent: "Opponent"
#    rank: "Rank"
#    score: "Score"
#    win: "Win"
#    loss: "Loss"
#    tie: "Tie"
#    easy: "Easy"
#    medium: "Medium"
#    hard: "Hard"
#    player: "Player"
#    player_level: "Level" # Like player level 5, not like level: Dungeons of Kithgard
#    warrior: "Warrior"
#    ranger: "Ranger"
#    wizard: "Wizard"
#    first_name: "First Name"
#    last_name: "Last Name"
#    last_initial: "Last Initial"
#    username: "Username"
#    contact_us: "Contact Us"
#    close_window: "Close Window"
#    learn_more: "Learn More"

#  units:
#    second: "second"
#    seconds: "seconds"
#    minute: "minute"
#    minutes: "minutes"
#    hour: "hour"
#    hours: "hours"
#    day: "day"
#    days: "days"
#    week: "week"
#    weeks: "weeks"
#    month: "month"
#    months: "months"
#    year: "year"
#    years: "years"

#  play_level:
#    directions: "Directions"
#    edit_level: "Edit Level"
#    explore_codecombat: "Explore CodeCombat"
#    finished_hoc: "I'm finished with my Hour of Code"
#    get_certificate: "Get your certificate!"
#    level_complete: "Level Complete"
#    completed_level: "Completed Level:"
#    course: "Course:"
#    done: "Done"
#    next_level: "Next Level"
#    next_game: "Next game"
#    languages: "Languages"
#    programming_language: "Programming language"
#    show_menu: "Show game menu"
#    home: "Home" # Not used any more, will be removed soon.
#    level: "Level" # Like "Level: Dungeons of Kithgard"
#    skip: "Skip"
#    game_menu: "Game Menu"
#    restart: "Restart"
#    goals: "Goals"
#    goal: "Goal"
#    running: "Running..."
#    success: "Success!"
#    incomplete: "Incomplete"
#    timed_out: "Ran out of time"
#    failing: "Failing"
#    reload: "Reload"
#    reload_title: "Reload All Code?"
#    reload_really: "Are you sure you want to reload this level back to the beginning?"
#    reload_confirm: "Reload All"
#    test_level: "Test Level"
#    victory: "Victory"
#    victory_title_prefix: ""
#    victory_title_suffix: " Complete"
#    victory_sign_up: "Sign Up to Save Progress"
#    victory_sign_up_poke: "Want to save your code? Create a free account!"
#    victory_rate_the_level: "How fun was this level?"
#    victory_return_to_ladder: "Return to Ladder"
#    victory_saving_progress: "Saving Progress"
#    victory_go_home: "Go Home"
#    victory_review: "Tell us more!"
#    victory_review_placeholder: "How was the level?"
#    victory_hour_of_code_done: "Are You Done?"
#    victory_hour_of_code_done_yes: "Yes, I'm finished with my Hour of Code™!"
#    victory_experience_gained: "XP Gained"
#    victory_gems_gained: "Gems Gained"
#    victory_new_item: "New Item"
#    victory_new_hero: "New Hero"
#    victory_viking_code_school: "Holy smokes, that was a hard level you just beat! If you aren't already a software developer, you should be. You just got fast-tracked for acceptance with Viking Code School, where you can take your skills to the next level and become a professional web developer in 14 weeks."
#    victory_become_a_viking: "Become a Viking"
#    victory_no_progress_for_teachers: "Progress is not saved for teachers. But, you can add a student account to your classroom for yourself."
#    tome_cast_button_run: "Run"
#    tome_cast_button_running: "Running"
#    tome_cast_button_ran: "Ran"
#    tome_submit_button: "Submit"
#    tome_reload_method: "Reload original code to restart the level"
#    tome_available_spells: "Available Spells"
#    tome_your_skills: "Your Skills"
#    hints: "Hints"
#    hints_title: "Hint {{number}}"
#    code_saved: "Code Saved"
#    skip_tutorial: "Skip (esc)"
#    keyboard_shortcuts: "Key Shortcuts"
#    loading_start: "Start Level"
#    problem_alert_title: "Fix Your Code"
#    time_current: "Now:"
#    time_total: "Max:"
#    time_goto: "Go to:"
#    non_user_code_problem_title: "Unable to Load Level"
#    infinite_loop_title: "Infinite Loop Detected"
#    infinite_loop_description: "The initial code to build the world never finished running. It's probably either really slow or has an infinite loop. Or there might be a bug. You can either try running this code again or reset the code to the default state. If that doesn't fix it, please let us know."
#    check_dev_console: "You can also open the developer console to see what might be going wrong."
#    check_dev_console_link: "(instructions)"
#    infinite_loop_try_again: "Try Again"
#    infinite_loop_reset_level: "Reset Level"
#    infinite_loop_comment_out: "Comment Out My Code"
#    tip_toggle_play: "Toggle play/paused with Ctrl+P."
#    tip_scrub_shortcut: "Use Ctrl+[ and Ctrl+] to rewind and fast-forward."
#    tip_guide_exists: "Click the guide, inside game menu (at the top of the page), for useful info."
#    tip_open_source: "CodeCombat is 100% open source!"
#    tip_tell_friends: "Enjoying CodeCombat? Tell your friends about us!"
#    tip_beta_launch: "CodeCombat launched its beta in October, 2013."
#    tip_think_solution: "Think of the solution, not the problem."
#    tip_theory_practice: "In theory, there is no difference between theory and practice. But in practice, there is. - Yogi Berra"
#    tip_error_free: "There are two ways to write error-free programs; only the third one works. - Alan Perlis"
#    tip_debugging_program: "If debugging is the process of removing bugs, then programming must be the process of putting them in. - Edsger W. Dijkstra"
#    tip_forums: "Head over to the forums and tell us what you think!"
#    tip_baby_coders: "In the future, even babies will be Archmages."
#    tip_morale_improves: "Loading will continue until morale improves."
#    tip_all_species: "We believe in equal opportunities to learn programming for all species."
#    tip_reticulating: "Reticulating spines."
#    tip_harry: "Yer a Wizard, "
#    tip_great_responsibility: "With great coding skill comes great debug responsibility."
#    tip_munchkin: "If you don't eat your vegetables, a munchkin will come after you while you're asleep."
#    tip_binary: "There are only 10 types of people in the world: those who understand binary, and those who don't."
#    tip_commitment_yoda: "A programmer must have the deepest commitment, the most serious mind. ~ Yoda"
#    tip_no_try: "Do. Or do not. There is no try. - Yoda"
#    tip_patience: "Patience you must have, young Padawan. - Yoda"
#    tip_documented_bug: "A documented bug is not a bug; it is a feature."
#    tip_impossible: "It always seems impossible until it's done. - Nelson Mandela"
#    tip_talk_is_cheap: "Talk is cheap. Show me the code. - Linus Torvalds"
#    tip_first_language: "The most disastrous thing that you can ever learn is your first programming language. - Alan Kay"
#    tip_hardware_problem: "Q: How many programmers does it take to change a light bulb?  A: None, it's a hardware problem."
#    tip_hofstadters_law: "Hofstadter's Law: It always takes longer than you expect, even when you take into account Hofstadter's Law."
#    tip_premature_optimization: "Premature optimization is the root of all evil. - Donald Knuth"
#    tip_brute_force: "When in doubt, use brute force. - Ken Thompson"
#    tip_extrapolation: "There are only two kinds of people: those that can extrapolate from incomplete data..."
#    tip_superpower: "Coding is the closest thing we have to a superpower."
#    tip_control_destiny: "In real open source, you have the right to control your own destiny. - Linus Torvalds"
#    tip_no_code: "No code is faster than no code."
#    tip_code_never_lies: "Code never lies, comments sometimes do. — Ron Jeffries"
#    tip_reusable_software: "Before software can be reusable it first has to be usable."
#    tip_optimization_operator: "Every language has an optimization operator. In most languages that operator is ‘//’"
#    tip_lines_of_code: "Measuring programming progress by lines of code is like measuring aircraft building progress by weight. — Bill Gates"
#    tip_source_code: "I want to change the world but they would not give me the source code."
#    tip_javascript_java: "Java is to JavaScript what Car is to Carpet. - Chris Heilmann"
#    tip_move_forward: "Whatever you do, keep moving forward. - Martin Luther King Jr."
#    tip_google: "Have a problem you can't solve? Google it!"
#    tip_adding_evil: "Adding a pinch of evil."
#    tip_hate_computers: "That's the thing about people who think they hate computers. What they really hate is lousy programmers. - Larry Niven"
#    tip_open_source_contribute: "You can help CodeCombat improve!"
#    tip_recurse: "To iterate is human, to recurse divine. - L. Peter Deutsch"
#    tip_free_your_mind: "You have to let it all go, Neo. Fear, doubt, and disbelief. Free your mind. - Morpheus"
#    tip_strong_opponents: "Even the strongest of opponents always has a weakness. - Itachi Uchiha"
#    tip_paper_and_pen: "Before you start coding, you can always plan with a sheet of paper and a pen."
#    tip_solve_then_write: "First, solve the problem. Then, write the code. - John Johnson"
#    tip_compiler_ignores_comments: "Sometimes I think that the compiler ignores my comments."
#    tip_understand_recursion: "The only way to understand recursion is to understand recursion."
#    tip_life_and_polymorphism: "Open Source is like a totally polymorphic heterogeneous structure: All types are welcome."
#    tip_mistakes_proof_of_trying: "Mistakes in your code are just proof that you are trying."
#    tip_adding_orgres: "Rounding up ogres."
#    tip_sharpening_swords: "Sharpening the swords."
#    tip_ratatouille: "You must not let anyone define your limits because of where you come from. Your only limit is your soul. - Gusteau, Ratatouille"
#    tip_nemo: "When life gets you down, want to know what you've gotta do? Just keep swimming, just keep swimming. - Dory, Finding Nemo"
#    tip_internet_weather: "Just move to the internet, it's great here. We get to live inside where the weather is always awesome. - John Green"
#    tip_nerds: "Nerds are allowed to love stuff, like jump-up-and-down-in-the-chair-can't-control-yourself love it. - John Green"
#    tip_self_taught: "I taught myself 90% of what I've learned. And that's normal! - Hank Green"
#    tip_luna_lovegood: "Don't worry, you're just as sane as I am. - Luna Lovegood"
#    tip_good_idea: "The best way to have a good idea is to have a lot of ideas. - Linus Pauling"
#    tip_programming_not_about_computers: "Computer Science is no more about computers than astronomy is about telescopes. - Edsger Dijkstra"
#    tip_mulan: "Believe you can, then you will. - Mulan"

#  play_game_dev_level:
#    created_by: "Created by {{name}}"
#    restart: "Restart Level"
#    play: "Play Level"
#    play_more_codecombat: "Play More CodeCombat"
#    default_student_instructions: "Click to control your hero and win your game!"

#  game_menu:
#    inventory_tab: "Inventory"
#    save_load_tab: "Save/Load"
#    options_tab: "Options"
#    guide_tab: "Guide"
#    guide_video_tutorial: "Video Tutorial"
#    guide_tips: "Tips"
#    multiplayer_tab: "Multiplayer"
#    auth_tab: "Sign Up"
#    inventory_caption: "Equip your hero"
#    choose_hero_caption: "Choose hero, language"
#    save_load_caption: "... and view history"
#    options_caption: "Configure settings"
#    guide_caption: "Docs and tips"
#    multiplayer_caption: "Play with friends!"
#    auth_caption: "Save your progress."

#  leaderboard:
#    view_other_solutions: "View Leaderboards"
#    scores: "Scores"
#    top_players: "Top Players by"
#    day: "Today"
#    week: "This Week"
#    all: "All-Time"
#    time: "Time"
#    damage_taken: "Damage Taken"
#    damage_dealt: "Damage Dealt"
#    difficulty: "Difficulty"
#    gold_collected: "Gold Collected"

#  inventory:
#    equipped_item: "Equipped"
#    required_purchase_title: "Required"
#    available_item: "Available"
#    restricted_title: "Restricted"
#    should_equip: "(double-click to equip)"
#    equipped: "(equipped)"
#    locked: "(locked)"
#    restricted: "(restricted in this level)"
#    equip: "Equip"
#    unequip: "Unequip"

#  buy_gems:
#    few_gems: "A few gems"
#    pile_gems: "Pile of gems"
#    chest_gems: "Chest of gems"
#    purchasing: "Purchasing..."
#    declined: "Your card was declined"
#    retrying: "Server error, retrying."
#    prompt_title: "Not Enough Gems"
#    prompt_body: "Do you want to get more?"
#    prompt_button: "Enter Shop"
#    recovered: "Previous gems purchase recovered. Please refresh the page."
#    price: "x{{gems}} / mo"
#    buy_premium: "Buy Premium"
#    purchase: "Purchase"
#    purchased: "Purchased"

#  earn_gems:
#    prompt_title: "Not Enough Gems"
#    prompt_body: "Keep playing to earn more!"

#  subscribe:
#    subscribe_modal_title: "CodeCombat Premium"
#    comparison_blurb: "Become a Master Coder - subscribe to <b>Premium</b> today!"
#    premium_pricing_prefix: "Get Premium for just"
#    premium_pricing_suffix: "and become a master coder."
#    premium: "Premium" # Make sure the following feature translations don't go onto two lines
#    free: "Free"
#    month: "month"
#    must_be_logged: "You must be logged in first. Please create an account or log in from the menu above."
#    subscribe_title: "Subscribe" # Actually used in subscribe buttons, too
#    unsubscribe: "Unsubscribe"
#    confirm_unsubscribe: "Confirm Unsubscribe"
#    never_mind: "Never Mind, I Still Love You"
#    thank_you_months_prefix: "Thank you for supporting us these last"
#    thank_you_months_suffix: "months."
#    thank_you: "Thank you for supporting CodeCombat."
#    sorry_to_see_you_go: "Sorry to see you go! Please let us know what we could have done better."
#    unsubscribe_feedback_placeholder: "O, what have we done?"
#    parent_button: "Ask your parent"
#    parent_email_description: "We'll email them so they can buy you a CodeCombat subscription."
#    parent_email_input_invalid: "Email address invalid."
#    parent_email_input_label: "Parent email address"
#    parent_email_input_placeholder: "Enter parent email"
#    parent_email_send: "Send Email"
#    parent_email_sent: "Email sent!"
#    parent_email_title: "What's your parent's email?"
#    parents: "For Parents"
#    parents_title: "Dear Parent: Your child is learning to code. Will you help them continue?"
#    parents_blurb1: "Your child has played __nLevels__ levels and learned programming basics. Help cultivate their interest and buy them a subscription so they can keep playing."
#    parents_blurb1a: "Computer programming is an essential skill that your child will undoubtedly use as an adult. By 2020, basic software skills will be needed by 77% of jobs, and software engineers are in high demand across the world. Did you know that Computer Science is the highest-paid university degree?"
#    parents_blurb2: "For ${{price}} USD/mo, your child will get new challenges every week and personal email support from professional programmers."
#    parents_blurb3: "No Risk: 100% money back guarantee, easy 1-click unsubscribe."
#    payment_methods: "Payment Methods"
#    payment_methods_title: "Accepted Payment Methods"
#    payment_methods_blurb1: "We currently accept credit cards and Alipay. You can also PayPal {{three_month_price}} USD to nick@codecombat.com with your account email in the memo to purchase three months' subscription and gems, or ${{year_price}} for a year."
#    payment_methods_blurb2: "If you require an alternate form of payment, please contact"
#    sale_button: "Sale!"
#    sale_button_title: "Save $21 when you purchase a 1 year subscription"
#    stripe_description: "Monthly Subscription"
#    stripe_description_year_sale: "1 Year Subscription (${{discount}} discount)"
#    subscription_required_to_play: "You'll need a subscription to play this level."
#    unlock_help_videos: "Subscribe to unlock all video tutorials."
#    personal_sub: "Personal Subscription" # Accounts Subscription View below
#    loading_info: "Loading subscription information..."
#    managed_by: "Managed by"
#    will_be_cancelled: "Will be cancelled on"
#    currently_free: "You currently have a free subscription"
#    currently_free_until: "You currently have a subscription until"
#    free_subscription: "Free subscription"
#    was_free_until: "You had a free subscription until"
#    managed_subs: "Managed Subscriptions"
#    subscribing: "Subscribing..."
#    current_recipients: "Current Recipients"
#    unsubscribing: "Unsubscribing"
#    subscribe_prepaid: "Click Subscribe to use prepaid code"
#    using_prepaid: "Using prepaid code for monthly subscription"
#    feature_levels: "Access __premiumLevelsCount__ levels available"
#    feature_gems: "Receive __gems__ gems per month"
#    feature_heroes: "Unlock exclusive heroes"
#    feature_games: "Make games for your friends"
#    feature_websites: "Build websites and apps"
#    feature_items: "Equip more powerful items"
#    month_price: "$__price__/mo"
#    lifetime: "Lifetime Subscription"
#    lifetime_price: "$__price__"
#    year_subscription: "Yearly Subscription"
#    year_price: "$__price__/year"
#    kids_message_1: "Kids! We'll send an email to your parents so they can purchase a subscription for you."
#    kids_message_2: "Ask Your Parent"
#    support_part1: "Need help with payment options? Email"
#    support_part2: "support@codecombat.com"
#    support_part3: "if you have any questions."

#  announcement:
#    cuddly_companions: "Cuddly Companions!"
#    kindling_name: "Kindling Elemental"
#    kindling_description: "Kindling Elementals just want to keep you warm at night. And during the day. All the time, really."
#    griffin_name: "Baby Griffin"
#    griffin_description: "Griffins are half eagle, half lion, all adorable."
#    raven_name: "Raven"
#    raven_description: "Ravens are excellent at gathering shiny bottles full of health for you."
#    mimic_name: "Mimic"
#    mimic_description: "Mimics can pick up coins for you. Move them on top of coins to increase your gold supply."
#    cougar_name: "Cougar"
#    cougar_description: "Cougars like to earn a PhD by Purring Happily Daily."
#    fox_name: "Blue Fox"
#    fox_description: "Blue foxes are very clever and love digging in the dirt and snow!"
#    pugicorn_name: "Pugicorn"
#    pugicorn_description: "Pugicorns are some of the rarest creatures and can cast spells!"
#    wolf_name: "Wolf Pup"
#    wolf_description: "Wolf pups excel in hunting, gathering, and playing a mean game of hide-and-seek!"
#    ball_name: "Red Squeaky Ball"
#    ball_description: "ball.squeak()"
#    collect_pets: "Collect pets for your heroes!"
#    each_pet: "Each pet has a unique helper ability!"
#    upgrade_to_premium: "Become a {{subscriber}} to equip pets."
#    play_second_kithmaze: "Play {{the_second_kithmaze}} to unlock the Wolf Pup!"
#    the_second_kithmaze: "The Second Kithmaze"
#    keep_playing: "Keep playing to discover the first pet!"
#    coming_soon: "Coming soon"
#    now_available: "Now available for subscribers!"
#    subscriber: "subscriber"

#  premium_features:
#    get_premium: "Get<br>CodeCombat<br>Premium" # Fit into the banner on the /features page
#    master_coder: "Become a Master Coder by subscribing today!"
#    subscribe_now: "Subscribe Now"
#    hero_blurb_1: "Get access to __premiumHeroesCount__ super-charged subscriber-only heroes! Harness the unstoppable power of Okar Stompfoot, the deadly precision of Naria of the Leaf, or summon \"adorable\" skeletons with Nalfar Cryptor."
#    hero_blurb_2: "Premium Warriors unlock stunning martial skills like Warcry, Stomp, and Hurl Enemy. Or, play as a Ranger, using stealth and bows, throwing knives, traps! Try your skill as a true coding Wizard, and unleash a powerful array of Primordial, Necromantic or Elemental magic!"
#    hero_caption: "Exciting new heroes!"
#    pet_blurb_1: "Pets aren't just adorable companions, they also provide unique functionality and methods. The Baby Griffin can fly over obstacles while helping the hero, the Wolf Pup can fetch potions, and the Cougar can speak!"
#    pet_blurb_2: "Collect all the pets to discover their unique abilities!"
#    pet_caption: "Adopt pets to accompany your hero!"
#    game_dev_blurb: "Learn game scripting and build new levels to share with your friends! Place the items you want, write code for unit logic and behavior, and see if your friends can beat the level!"
#    game_dev_caption: "Design your own games to challenge your friends!"
#    everything_in_premium: "Everything you get in CodeCombat Premium:"
#    list_gems: "Receive bonus gems every month to buy gear, pets, and heroes"
#    list_levels: "Gain access to __premiumLevelsCount__ more levels"
#    list_heroes: "Unlock exclusive heroes, include Ranger and Wizard classes"
#    list_game_dev: "Make and share games with friends"
#    list_web_dev: "Build websites and interactive apps"
#    list_items: "Equip Premium-only items like pets"
#    list_support: "Get Premium support to help you debug tricky code"
#    list_clans: "Create private clans to invite your friends and compete on a group leaderboard"

#  choose_hero:
#    choose_hero: "Choose Your Hero"
#    programming_language: "Programming Language"
#    programming_language_description: "Which programming language do you want to use?"
#    default: "Default"
#    experimental: "Experimental"
#    python_blurb: "Simple yet powerful, great for beginners and experts."
#    javascript_blurb: "The language of the web. (Not the same as Java.)"
#    coffeescript_blurb: "Nicer JavaScript syntax."
#    lua_blurb: "Game scripting language."
#    java_blurb: "(Subscriber Only) Android and enterprise."
#    status: "Status"
#    weapons: "Weapons"
#    weapons_warrior: "Swords - Short Range, No Magic"
#    weapons_ranger: "Crossbows, Guns - Long Range, No Magic"
#    weapons_wizard: "Wands, Staffs - Long Range, Magic"
#    attack: "Damage" # Can also translate as "Attack"
#    health: "Health"
#    speed: "Speed"
#    regeneration: "Regeneration"
#    range: "Range" # As in "attack or visual range"
#    blocks: "Blocks" # As in "this shield blocks this much damage"
#    backstab: "Backstab" # As in "this dagger does this much backstab damage"
#    skills: "Skills"
#    attack_1: "Deals"
#    attack_2: "of listed"
#    attack_3: "weapon damage."
#    health_1: "Gains"
#    health_2: "of listed"
#    health_3: "armor health."
#    speed_1: "Moves at"
#    speed_2: "meters per second."
#    available_for_purchase: "Available for Purchase" # Shows up when you have unlocked, but not purchased, a hero in the hero store
#    level_to_unlock: "Level to unlock:" # Label for which level you have to beat to unlock a particular hero (click a locked hero in the store to see)
#    restricted_to_certain_heroes: "Only certain heroes can play this level."

#  skill_docs:
#    function: "function" # skill types
#    method: "method"
#    snippet: "snippet"
#    number: "number"
#    array: "array"
#    object: "object"
#    string: "string"
#    writable: "writable" # Hover over "attack" in Your Skills while playing a level to see most of this
#    read_only: "read-only"
#    action: "Action"
#    spell: "Spell"
#    action_name: "name"
#    action_cooldown: "Takes"
#    action_specific_cooldown: "Cooldown"
#    action_damage: "Damage"
#    action_range: "Range"
#    action_radius: "Radius"
#    action_duration: "Duration"
#    example: "Example"
#    ex: "ex" # Abbreviation of "example"
#    current_value: "Current Value"
#    default_value: "Default value"
#    parameters: "Parameters"
#    required_parameters: "Required Parameters"
#    optional_parameters: "Optional Parameters"
#    returns: "Returns"
#    granted_by: "Granted by"

#  save_load:
#    granularity_saved_games: "Saved"
#    granularity_change_history: "History"

#  options:
#    general_options: "General Options" # Check out the Options tab in the Game Menu while playing a level
#    volume_label: "Volume"
#    music_label: "Music"
#    music_description: "Turn background music on/off."
#    editor_config_title: "Editor Configuration"
#    editor_config_livecompletion_label: "Live Autocompletion"
#    editor_config_livecompletion_description: "Displays autocomplete suggestions while typing."
#    editor_config_invisibles_label: "Show Invisibles"
#    editor_config_invisibles_description: "Displays invisibles such as spaces or tabs."
#    editor_config_indentguides_label: "Show Indent Guides"
#    editor_config_indentguides_description: "Displays vertical lines to see indentation better."
#    editor_config_behaviors_label: "Smart Behaviors"
#    editor_config_behaviors_description: "Autocompletes brackets, braces, and quotes."

#  about:
#    main_title: "If you want to learn to program, you need to write (a lot of) code."
#    main_description: "At CodeCombat, our job is to make sure you're doing that with a smile on your face."
#    mission_link: "Mission"
#    team_link: "Team"
#    story_link: "Story"
#    press_link: "Press"
#    mission_title: "Our mission: make programming accessible to every student on Earth."
#    mission_description_1: "<strong>Programming is magic</strong>. It's the ability to create things from pure imagination. We started CodeCombat to give learners the feeling of wizardly power at their fingertips by using <strong>typed code</strong>."
#    mission_description_2: "As it turns out, that enables them to learn faster too. WAY faster. It's like having a conversation instead of reading a manual. We want to bring that conversation to every school and to <strong>every student</strong>, because everyone should have the chance to learn the magic of programming."
#    team_title: "Meet the CodeCombat team"
#    team_values: "We value open and respectful dialog, where the best idea wins. Our decisions are grounded in customer research and our process is focused on delivering tangible results for them. Everyone is hands-on, from our CEO to our GitHub contributors, because we value growth and learning in our team."
#    nick_title: "Cofounder, CEO"
#    nick_blurb: "Motivation Guru"
#    matt_title: "Cofounder, CTO"
#    cat_title: "Game Designer"
#    cat_blurb: "Airbender"
#    scott_title: "Cofounder, Software Engineer"
#    scott_blurb: "Reasonable One"
#    maka_title: "Customer Advocate"
#    maka_blurb: "Storyteller"
#    rob_title: "Software Engineer"
#    rob_blurb: "Codes things and stuff"
#    josh_c_title: "Game Designer"
#    josh_c_blurb: "Designs games"
#    robin_title: "Product Manager"
#    robin_blurb: "Ships things"
#    josh_title: "Game Designer"
#    josh_blurb: "Floor Is Lava"
#    phoenix_title: "Software Engineer"
#    nolan_title: "Territory Manager"
#    elliot_title: "Partnership Manager"
#    elliot_blurb: "Mindreader"
#    lisa_title: "School Specialist"
#    lisa_blurb: "A gritty one"
#    sean_title: "Territory Manager"
#    liz_title: "Territory Manager"
#    retrostyle_title: "Illustration"
#    retrostyle_blurb: "RetroStyle Games"
#    jose_title: "Music"
#    jose_blurb: "Taking Off"
#    community_title: "...and our open-source community"
#    community_subtitle: "Over 500 contributors have helped build CodeCombat, with more joining every week!"
#    community_description_3: "CodeCombat is a"
#    community_description_link_2: "community project"
#    community_description_1: "with hundreds of players volunteering to create levels, contribute to our code to add features, fix bugs, playtest, and even translate the game into 50 languages so far. Employees, contributors and the site gain by sharing ideas and pooling effort, as does the open source community in general. The site is built on numerous open source projects, and we are open sourced to give back to the community and provide code-curious players a familiar project to explore and experiment with. Anyone can join the CodeCombat community! Check out our"
#    community_description_link: "contribute page"
#    community_description_2: "for more info."
#    number_contributors: "Over 450 contributors have lent their support and time to this project."
#    story_title: "Our story so far"
#    story_subtitle: "Since 2013, CodeCombat has grown from a mere set of sketches to a living, thriving game."
#    story_statistic_1a: "5,000,000+"
#    story_statistic_1b: "total players"
#    story_statistic_1c: "have started their programming journey through CodeCombat"
#    story_statistic_2a: "We’ve been translated into over 50 languages — our players hail from"
#    story_statistic_2b: "200+ countries"
#    story_statistic_3a: "Together, they have written"
#    story_statistic_3b: "1 billion lines of code and counting"
#    story_statistic_3c: "across many different programming languages"
#    story_long_way_1: "Though we've come a long way..."
#    story_sketch_caption: "Nick's very first sketch depicting a programming game in action."
#    story_long_way_2: "we still have much to do before we complete our quest, so..."
#    jobs_title: "Come work with us and help write CodeCombat history!"
#    jobs_subtitle: "Don't see a good fit but interested in keeping in touch? See our \"Create Your Own\" listing."
#    jobs_benefits: "Employee Benefits"
#    jobs_benefit_4: "Unlimited vacation"
#    jobs_benefit_5: "Professional development and continuing education support – free books and games!"
#    jobs_benefit_6: "Medical (gold), dental, vision, commuter"
#    jobs_benefit_7: "Sit-stand desks for all"
#    jobs_benefit_9: "10-year option exercise window"
#    jobs_benefit_10: "Maternity leave: 10 weeks paid, next 6 @ 55% salary"
#    jobs_benefit_11: "Paternity leave: 10 weeks paid"
#    learn_more: "Learn More"
#    jobs_custom_title: "Create Your Own"
#    jobs_custom_description: "Are you passionate about CodeCombat but don't see a job listed that matches your qualifications? Write us and show how you think you can contribute to our team. We'd love to hear from you!"
#    jobs_custom_contact_1: "Send us a note at"
#    jobs_custom_contact_2: "introducing yourself and we might get in touch in the future!"
#    contact_title: "Press & Contact"
#    contact_subtitle: "Need more information? Get in touch with us at"
#    screenshots_title: "Game Screenshots"
#    screenshots_hint: "(click to view full size)"
#    downloads_title: "Download Assets & Information"
#    about_codecombat: "About CodeCombat"
#    logo: "Logo"
#    screenshots: "Screenshots"
#    character_art: "Character Art"
#    download_all: "Download All"
#    previous: "Previous"
#    location_title: "We're located in downtown SF:"

#  teachers:
#    licenses_needed: "Licenses needed"

#  special_offer:
#    special_offer: "Special Offer"
#    project_based_title: "Project-Based Courses"
#    project_based_description: "Web and Game Development courses feature shareable final projects."
#    great_for_clubs_title: "Great for clubs and electives"
#    great_for_clubs_description: "Teachers can purchase up to __maxQuantityStarterLicenses__ Starter Licenses per year."
#    low_price_title: "Just __starterLicensePrice__ per student"
#    low_price_description: "Starter Licenses are active for __starterLicenseLengthMonths__ months from purchase."
#    three_great_courses: "Three great courses included in the Starter License:"
#    license_limit_description: "Teachers can purchase up to __maxQuantityStarterLicenses__ Starter Licenses. You have already purchased __quantityAlreadyPurchased__. If you need more, contact __supportEmail__. Starter Licenses are valid for __starterLicenseLengthMonths__ months."
#    student_starter_license: "Student Starter License"
#    purchase_starter_licenses: "Purchase Starter Licenses"
#    purchase_starter_licenses_to_grant: "Purchase Starter Licenses to grant access to __starterLicenseCourseList__"
#    starter_licenses_can_be_used: "Starter Licenses can be used to assign additional courses immediately after purchase."
#    pay_now: "Pay Now"
#    we_accept_all_major_credit_cards: "We accept all major credit cards."
#    cs2_description: "builds on the foundation from Introduction to Computer Science, diving into if-statements, functions, events and more."
#    wd1_description: "introduces the basics of HTML and CSS while teaching skills needed for students to build their first webpage."
#    gd1_description: "uses syntax students are already familiar with to show them how to build and share their own playable game levels."
#    see_an_example_project: "see an example project"
#    get_started_today: "Get started today!"
#    want_all_the_courses: "Want all the courses? Request information on our Full Licenses."
#    compare_license_types: "Compare License Types:"
#    cs: "Computer Science"
#    wd: "Web Development"
#    wd1: "Web Development 1"
#    gd: "Game Development"
#    gd1: "Game Development 1"
#    maximum_students: "Maximum # of Students"
#    unlimited: "Unlimited"
#    priority_support: "Priority support"
#    yes: "Yes"
#    price_per_student: "__price__ per student"
#    pricing: "Pricing"
#    free: "Free"
#    purchase: "Purchase"
#    courses_prefix: "Courses"
#    courses_suffix: ""
#    course_prefix: "Course"
#    course_suffix: ""

#  teachers_quote:
#    subtitle: "Get your students started in less than an hour. You'll be able to <strong>create a class, add students, and monitor their progress</strong> as they learn computer science."
#    email_exists: "User exists with this email."
#    phone_number: "Phone number"
#    phone_number_help: "Where can we reach you during the workday?"
#    primary_role_label: "Your Primary Role"
#    role_default: "Select Role"
#    primary_role_default: "Select Primary Role"
#    purchaser_role_default: "Select Purchaser Role"
#    tech_coordinator: "Technology coordinator"
#    advisor: "Curriculum Specialist/Advisor"
#    principal: "Principal"
#    superintendent: "Superintendent"
#    parent: "Parent"
#    purchaser_role_label: "Your Purchaser Role"
#    influence_advocate: "Influence/Advocate"
#    evaluate_recommend: "Evaluate/Recommend"
#    approve_funds: "Approve Funds"
#    no_purchaser_role: "No role in purchase decisions"
#    district_label: "District"
#    district_name: "District Name"
#    district_na: "Enter N/A if not applicable"
#    organization_label: "School"
#    school_name: "School Name"
#    city: "City"
#    state: "State"
#    country: "Country"
#    num_students_help: "How many students do you anticipate using CodeCombat with?"
#    num_students_default: "Select Range"
#    education_level_label: "Education Level of Students"
#    education_level_help: "Choose as many as apply."
#    elementary_school: "Elementary School"
#    high_school: "High School"
#    please_explain: "(please explain)"
#    middle_school: "Middle School"
#    college_plus: "College or higher"
#    referrer: "How did you hear about us?"
#    referrer_help: "For example: from another teacher, a conference, your students, Code.org, etc."
#    anything_else: "Anything else we should know?"
#    thanks_header: "Request Received!"
#    thanks_sub_header: "Thanks for expressing interest in CodeCombat for your school."
#    thanks_p: "We'll be in touch soon! If you need to get in contact, you can reach us at:"
#    back_to_classes: "Back to Classes"
#    finish_signup: "Finish creating your teacher account:"
#    finish_signup_p: "Create an account to set up a class, add your students, and monitor their progress as they learn computer science."
#    signup_with: "Sign up with:"
#    connect_with: "Connect with:"
#    conversion_warning: "WARNING: Your current account is a <em>Student Account</em>. Once you submit this form, your account will be updated to a Teacher Account."
#    learn_more_modal: "Teacher accounts on CodeCombat have the ability to monitor student progress, assign licenses and manage classrooms. Teacher accounts cannot be a part of a classroom - if you are currently enrolled in a class using this account, you will no longer be able to access it once you update to a Teacher Account."
#    create_account: "Create a Teacher Account"
#    create_account_subtitle: "Get access to teacher-only tools for using CodeCombat in the classroom.  <strong>Set up a class</strong>, add your students, and <strong>monitor their progress</strong>!"
#    convert_account_title: "Update to Teacher Account"
#    not: "Not"

#  versions:
#    save_version_title: "Save New Version"
#    new_major_version: "New Major Version"
#    submitting_patch: "Submitting Patch..."
#    cla_prefix: "To save changes, first you must agree to our"
#    cla_url: "CLA"
#    cla_suffix: "."
#    cla_agree: "I AGREE"
#    owner_approve: "An owner will need to approve it before your changes will become visible."

#  contact:
#    contact_us: "Contact CodeCombat"
#    welcome: "Good to hear from you! Use this form to send us email. "
#    forum_prefix: "For anything public, please try "
#    forum_page: "our forum"
#    forum_suffix: " instead."
#    faq_prefix: "There's also a"
#    faq: "FAQ"
#    subscribe_prefix: "If you need help figuring out a level, please"
#    subscribe: "buy a CodeCombat subscription"
#    subscribe_suffix: "and we'll be happy to help you with your code."
#    subscriber_support: "Since you're a CodeCombat subscriber, your email will get our priority support."
#    screenshot_included: "Screenshot included."
#    where_reply: "Where should we reply?"
#    send: "Send Feedback"

#  account_settings:
#    title: "Account Settings"
#    not_logged_in: "Log in or create an account to change your settings."
#    me_tab: "Me"
#    picture_tab: "Picture"
#    delete_account_tab: "Delete Your Account"
#    wrong_email: "Wrong Email"
#    wrong_password: "Wrong Password"
#    upload_picture: "Upload a picture"
#    delete_this_account: "Delete this account permanently"
#    reset_progress_tab: "Reset All Progress"
#    reset_your_progress: "Clear all your progress and start over"
#    god_mode: "God Mode"
#    emails_tab: "Emails"
#    admin: "Admin"
#    manage_subscription: "Click here to manage your subscription."
#    new_password: "New Password"
#    new_password_verify: "Verify"
#    type_in_email: "Type in your email or username to confirm account deletion."
#    type_in_email_progress: "Type in your email to confirm deleting your progress."
#    type_in_password: "Also, type in your password."
#    email_subscriptions: "Email Subscriptions"
#    email_subscriptions_none: "No Email Subscriptions."
#    email_announcements: "Announcements"
#    email_announcements_description: "Get emails on the latest news and developments at CodeCombat."
#    email_notifications: "Notifications"
#    email_notifications_summary: "Controls for personalized, automatic email notifications related to your CodeCombat activity."
#    email_any_notes: "Any Notifications"
#    email_any_notes_description: "Disable to stop all activity notification emails."
#    email_news: "News"
#    email_recruit_notes: "Job Opportunities"
#    email_recruit_notes_description: "If you play really well, we may contact you about getting you a (better) job."
#    contributor_emails: "Contributor Class Emails"
#    contribute_prefix: "We're looking for people to join our party! Check out the "
#    contribute_page: "contribute page"
#    contribute_suffix: " to find out more."
#    email_toggle: "Toggle All"
#    error_saving: "Error Saving"
#    saved: "Changes Saved"
#    password_mismatch: "Password does not match."
#    password_repeat: "Please repeat your password."
#    file_size_limit: "(max file size: 1MB)"

#  keyboard_shortcuts:
#    keyboard_shortcuts: "Keyboard Shortcuts"
#    space: "Space"
#    enter: "Enter"
#    press_enter: "press enter"
#    escape: "Escape"
#    shift: "Shift"
#    run_code: "Run current code."
#    run_real_time: "Run in real time."
#    continue_script: "Continue past current script."
#    skip_scripts: "Skip past all skippable scripts."
#    toggle_playback: "Toggle play/pause."
#    scrub_playback: "Scrub back and forward through time."
#    single_scrub_playback: "Scrub back and forward through time by a single frame."
#    scrub_execution: "Scrub through current spell execution."
#    toggle_debug: "Toggle debug display."
#    toggle_grid: "Toggle grid overlay."
#    toggle_pathfinding: "Toggle pathfinding overlay."
#    beautify: "Beautify your code by standardizing its formatting."
#    maximize_editor: "Maximize/minimize code editor."

#  community:
#    main_title: "CodeCombat Community"
#    introduction: "Check out the ways you can get involved below and decide what sounds the most fun. We look forward to working with you!"
#    level_editor_prefix: "Use the CodeCombat"
#    level_editor_suffix: "to create and edit levels. Users have created levels for their classes, friends, hackathons, students, and siblings. If create a new level sounds intimidating you can start by forking one of ours!"
#    thang_editor_prefix: "We call units within the game 'thangs'. Use the"
#    thang_editor_suffix: "to modify the CodeCombat source artwork. Allow units to throw projectiles, alter the direction of an animation, change a unit's hit points, or upload your own vector sprites."
#    article_editor_prefix: "See a mistake in some of our docs? Want to make some instructions for your own creations? Check out the"
#    article_editor_suffix: "and help CodeCombat players get the most out of their playtime."
#    find_us: "Find us on these sites"
#    social_github: "Check out all our code on GitHub"
#    social_blog: "Read the CodeCombat blog on Sett"
#    social_discource: "Join the discussion on our Discourse forum"
#    social_facebook: "Like CodeCombat on Facebook"
#    social_twitter: "Follow CodeCombat on Twitter"
#    social_gplus: "Join CodeCombat on Google+"
#    social_slack: "Chat with us in the public CodeCombat Slack channel"
#    contribute_to_the_project: "Contribute to the project"

#  clans:
#    clan: "Clan"
#    clans: "Clans"
#    new_name: "New clan name"
#    new_description: "New clan description"
#    make_private: "Make clan private"
#    subs_only: "subscribers only"
#    create_clan: "Create New Clan"
#    private_preview: "Preview"
#    private_clans: "Private Clans"
#    public_clans: "Public Clans"
#    my_clans: "My Clans"
#    clan_name: "Clan Name"
#    name: "Name"
#    chieftain: "Chieftain"
#    edit_clan_name: "Edit Clan Name"
#    edit_clan_description: "Edit Clan Description"
#    edit_name: "edit name"
#    edit_description: "edit description"
#    private: "(private)"
#    summary: "Summary"
#    average_level: "Average Level"
#    average_achievements: "Average Achievements"
#    delete_clan: "Delete Clan"
#    leave_clan: "Leave Clan"
#    join_clan: "Join Clan"
#    invite_1: "Invite:"
#    invite_2: "*Invite players to this Clan by sending them this link."
#    members: "Members"
#    progress: "Progress"
#    not_started_1: "not started"
#    started_1: "started"
#    complete_1: "complete"
#    exp_levels: "Expand levels"
#    rem_hero: "Remove Hero"
#    status: "Status"
#    complete_2: "Complete"
#    started_2: "Started"
#    not_started_2: "Not Started"
#    view_solution: "Click to view solution."
#    view_attempt: "Click to view attempt."
#    latest_achievement: "Latest Achievement"
#    playtime: "Playtime"
#    last_played: "Last played"
#    leagues_explanation: "Play in a league against other clan members in these multiplayer arena instances."
#    track_concepts1: "Track concepts"
#    track_concepts2a: "learned by each student"
#    track_concepts2b: "learned by each member"
#    track_concepts3a: "Track levels completed for each student"
#    track_concepts3b: "Track levels completed for each member"
#    track_concepts4a: "See your students'"
#    track_concepts4b: "See your members'"
#    track_concepts5: "solutions"
#    track_concepts6a: "Sort students by name or progress"
#    track_concepts6b: "Sort members by name or progress"
#    track_concepts7: "Requires invitation"
#    track_concepts8: "to join"
#    private_require_sub: "Private clans require a subscription to create or join."

#  courses:
#    create_new_class: "Create New Class"
#    unnamed_class: "Unnamed Class"
#    edit_settings1: "Edit Class Settings"
#    add_students: "Add Students"
#    stats: "Statistics"
#    total_students: "Total students:"
#    average_time: "Average level play time:"
#    total_time: "Total play time:"
#    average_levels: "Average levels completed:"
#    total_levels: "Total levels completed:"
#    students: "Students"
#    concepts: "Concepts"
#    play_time: "Play time:"
#    completed: "Completed:"
#    enter_emails: "Separate each email address by a line break or commas"
#    send_invites: "Invite Students"
#    number_programming_students: "Number of Programming Students"
#    number_total_students: "Total Students in School/District"
#    enroll: "Enroll"
#    enroll_paid: "Enroll Students in Paid Courses"
#    get_enrollments: "Get More Licenses"
#    change_language: "Change Course Language"
#    keep_using: "Keep Using"
#    switch_to: "Switch To"
#    greetings: "Greetings!"
#    back_classrooms: "Back to my classrooms"
#    back_courses: "Back to my courses"
#    edit_details: "Edit class details"
#    purchase_enrollments: "Purchase Student Licenses"
#    remove_student: "remove student"
#    assign: "Assign"
#    to_assign: "to assign paid courses."
#    student: "Student"
#    teacher: "Teacher"
#    arena: "Arena"
#    available_levels: "Available Levels"
#    welcome_to_courses: "Adventurers, welcome to Courses!"
#    ready_to_play: "Ready to play?"
#    start_new_game: "Start New Game"
#    play_now_learn_header: "Play now to learn"
#    play_now_learn_1: "basic syntax to control your character"
#    play_now_learn_2: "while loops to solve pesky puzzles"
#    play_now_learn_3: "strings & variables to customize actions"
#    play_now_learn_4: "how to defeat an ogre (important life skills!)"
#    welcome_to_page: "My Student Dashboard"
#    my_classes: "Current Classes"
#    class_added: "Class successfully added!"
#    view_levels: "view all levels in course"
#    join_class: "Join A Class"
#    join_class_2: "Join class"
#    ask_teacher_for_code: "Ask your teacher if you have a CodeCombat class code! If so, enter it below:"
#    enter_c_code: "<Enter Class Code>"
#    join: "Join"
#    joining: "Joining class"
#    course_complete: "Course Complete"
#    play_arena: "Play Arena"
#    view_project: "View Project"
#    start: "Start"
#    last_level: "Last level played"
#    not_you: "Not you?"
#    continue_playing: "Continue Playing"
#    option1_header: "Invite Students by Email"
#    option1_body: "Note: If your students do not have email addresses, they can enter your unique Class Code when creating a Student Account to make email addresses optional."
#    remove_student1: "Remove Student"
#    are_you_sure: "Are you sure you want to remove this student from this class?"
#    remove_description1: "Student will lose access to this classroom and assigned classes. Progress and gameplay is NOT lost, and the student can be added back to the classroom at any time."
#    remove_description2: "The activated paid license will not be returned."
#    keep_student: "Keep Student"
#    removing_user: "Removing user"
#    subtitle: "Review course overviews and levels" # Flat style redesign
#    changelog: "View latest changes to course levels."
#    select_language: "Select language"
#    select_level: "Select level"
#    play_level: "Play Level"
#    concepts_covered: "Concepts covered"
#    view_guide_online: "Level Overviews and Solutions"
#    grants_lifetime_access: "Grants access to all Courses."
#    enrollment_credits_available: "Licenses Available:"
#    language_select: "Select a language" # ClassroomSettingsModal
#    language_cannot_change: "Language cannot be changed once students join a class."
#    avg_student_exp_label: "Average Student Programming Experience"
#    avg_student_exp_desc: "This will help us understand how to pace courses better."
#    avg_student_exp_select: "Select the best option"
#    avg_student_exp_none: "No Experience - little to no experience"
#    avg_student_exp_beginner: "Beginner - some exposure or block-based"
#    avg_student_exp_intermediate: "Intermediate - some experience with typed code"
#    avg_student_exp_advanced: "Advanced - extensive experience with typed code"
#    avg_student_exp_varied: "Varied Levels of Experience"
#    student_age_range_label: "Student Age Range"
#    student_age_range_younger: "Younger than 6"
#    student_age_range_older: "Older than 18"
#    student_age_range_to: "to"
#    create_class: "Create Class"
#    class_name: "Class Name"
#    teacher_account_restricted: "Your account is a teacher account and cannot access student content."
#    account_restricted: "A student account is required to access this page."
#    update_account_login_title: "Log in to update your account"
#    update_account_title: "Your account needs attention!"
#    update_account_blurb: "Before you can access your classes, choose how you want to use this account."
#    update_account_current_type: "Current Account Type:"
#    update_account_account_email: "Account Email/Username:"
#    update_account_am_teacher: "I am a teacher"
#    update_account_keep_access: "Keep access to classes I've created"
#    update_account_teachers_can: "Teacher accounts can:"
#    update_account_teachers_can1: "Create/manage/add classes"
#    update_account_teachers_can2: "Assign/enroll students in courses"
#    update_account_teachers_can3: "Unlock all course levels to try out"
#    update_account_teachers_can4: "Access new teacher-only features as we release them"
#    update_account_teachers_warning: "Warning: You will be removed from all classes that you have previously joined and will not be able to play as a student."
#    update_account_remain_teacher: "Remain a Teacher"
#    update_account_update_teacher: "Update to Teacher"
#    update_account_am_student: "I am a student"
#    update_account_remove_access: "Remove access to classes I have created"
#    update_account_students_can: "Student accounts can:"
#    update_account_students_can1: "Join classes"
#    update_account_students_can2: "Play through courses as a student and track your own progress"
#    update_account_students_can3: "Compete against classmates in arenas"
#    update_account_students_can4: "Access new student-only features as we release them"
#    update_account_students_warning: "Warning: You will not be able to manage any classes that you have previously created or create new classes."
#    unsubscribe_warning: "Warning: You will be unsubscribed from your monthly subscription."
#    update_account_remain_student: "Remain a Student"
#    update_account_update_student: "Update to Student"
#    need_a_class_code: "You'll need a Class Code for the class you're joining:"
#    update_account_not_sure: "Not sure which one to choose? Email"
#    update_account_confirm_update_student: "Are you sure you want to update your account to a Student experience?"
#    update_account_confirm_update_student2: "You will not be able to manage any classes that you have previously created or create new classes. Your previously created classes will be removed from CodeCombat and cannot be restored."
#    instructor: "Instructor: "
#    youve_been_invited_1: "You've been invited to join "
#    youve_been_invited_2: ", where you'll learn "
#    youve_been_invited_3: " with your classmates in CodeCombat."
#    by_joining_1: "By joining "
#    by_joining_2: "will be able to help reset your password if you forget or lose it. You can also verify your email address so that you can reset the password yourself!"
#    sent_verification: "We've sent a verification email to:"
#    you_can_edit: "You can edit your email address in "
#    account_settings: "Account Settings"
#    select_your_hero: "Select Your Hero"
#    select_your_hero_description: "You can always change your hero by going to your Courses page and clicking \"Change Hero\""
#    select_this_hero: "Select this Hero"
#    current_hero: "Current Hero:"
#    change_hero: "Change Hero"
#    web_dev_language_transition: "All classes program in HTML / JavaScript for this course.  Classes that have been using Python will start with extra JavaScript intro levels to ease the transition.  Classes that are already using JavaScript will skip the intro levels."
#    course_membership_required_to_play: "You'll need to join a course to play this level."
#    license_required_to_play: "Ask your teacher to assign a license to you so you can continue to play CodeCombat!"

#  teacher:
#    assigning_course: "Assigning course"
#    course_solution: "Course Solution"
#    level_overview_solutions: "Level Overview and Solutions"
#    no_student_assigned: "No students have been assigned this course."
#    paren_new: "(new)"
#    teacher_dashboard: "Teacher Dashboard" # Navbar
#    my_classes: "My Classes"
#    courses: "Course Guides"
#    enrollments: "Student Licenses"
#    resources: "Resources"
#    help: "Help"
#    language: "Language"
#    edit_class_settings: "edit class settings"
#    access_restricted: "Account Update Required"
#    teacher_account_required: "A teacher account is required to access this content."
#    create_teacher_account: "Create Teacher Account"
#    what_is_a_teacher_account: "What's a Teacher Account?"
#    teacher_account_explanation: "A CodeCombat Teacher account allows you to set up classrooms, monitor students’ progress as they work through courses, manage licenses and access resources to aid in your curriculum-building."
#    current_classes: "Current Classes"
#    archived_classes: "Archived Classes"
#    archived_classes_blurb: "Classes can be archived for future reference. Unarchive a class to view it in the Current Classes list again."
#    view_class: "view class"
#    archive_class: "archive class"
#    unarchive_class: "unarchive class"
#    unarchive_this_class: "Unarchive this class"
#    no_students_yet: "This class has no students yet."
#    no_students_yet_view_class: "View class to add students."
#    try_refreshing: "(You may need to refresh the page)"
#    create_new_class: "Create a New Class"
#    class_overview: "Class Overview" # View Class page
#    avg_playtime: "Average level playtime"
#    total_playtime: "Total play time"
#    avg_completed: "Average levels completed"
#    total_completed: "Total levels completed"
#    created: "Created"
#    concepts_covered: "Concepts covered"
#    earliest_incomplete: "Earliest incomplete level"
#    latest_complete: "Latest completed level"
#    enroll_student: "Enroll student"
#    apply_license: "Apply License"
#    revoke_license: "Revoke License"
#    course_progress: "Course Progress"
#    not_applicable: "N/A"
#    edit: "edit"
#    edit_2: "Edit"
#    remove: "remove"
#    latest_completed: "Latest completed:"
#    sort_by: "Sort by"
#    progress: "Progress"
#    completed: "Completed"
#    practice: "Practice"
#    started: "Started"
#    click_to_view_progress: "click to view progress"
#    no_progress: "No progress"
#    not_required: "Not required"
#    select_course: "Select course to view"
#    progress_color_key: "Progress color key:"
#    level_in_progress: "Level in Progress"
#    level_not_started: "Level Not Started"
#    project_or_arena: "Project or Arena"
#    students_not_assigned: "Students who have not been assigned {{courseName}}"
#    course_overview: "Course Overview"
#    copy_class_code: "Copy Class Code"
#    class_code_blurb: "Students can join your class using this Class Code. No email address is required when creating a Student account with this Class Code."
#    copy_class_url: "Copy Class URL"
#    class_join_url_blurb: "You can also post this unique class URL to a shared webpage."
#    add_students_manually: "Invite Students by Email"
#    bulk_assign: "Bulk-assign"
#    assigned_msg_1: "{{numberAssigned}} students were assigned {{courseName}}."
#    assigned_msg_2: "{{numberEnrolled}} licenses were applied."
#    assigned_msg_3: "You now have {{remainingSpots}} available licenses remaining."
#    assign_course: "Assign Course"
#    not_assigned_modal_title: "Courses were not assigned"
#    not_assigned_modal_starter_body_1: "This course requires a Starter License. You do not have enough Starter Licenses available to assign this course to all __selected__ selected students."
#    not_assigned_modal_starter_body_2: "Purchase Starter Licenses to grant access to this course."
#    not_assigned_modal_full_body_1: "This course requires a Full License. You do not have enough Full Licenses available to assign this course to all __selected__ selected students."
#    not_assigned_modal_full_body_2: "You only have __numFullLicensesAvailable__ Full Licenses available (__numStudentsWithoutFullLicenses__ students do not currently have a Full License active)."
#    not_assigned_modal_full_body_3: "Please select fewer students, or reach out to __supportEmail__ for assistance."
#    assign_to_selected_students: "Assign to Selected Students"
#    assigned: "Assigned"
#    enroll_selected_students: "Enroll Selected Students"
#    no_students_selected: "No students were selected."
#    show_students_from: "Show students from" # Enroll students modal
#    apply_licenses_to_the_following_students: "Apply Licenses to the Following Students"
#    students_have_licenses: "The following students already have licenses applied:"
#    all_students: "All Students"
#    apply_licenses: "Apply Licenses"
#    not_enough_enrollments: "Not enough licenses available."
#    enrollments_blurb: "Students are required to have a license to access any content after the first course."
#    how_to_apply_licenses: "How to Apply Licenses"
#    export_student_progress: "Export Student Progress (CSV)"
#    send_email_to: "Send Recover Password Email to:"
#    email_sent: "Email sent"
#    send_recovery_email: "Send recovery email"
#    enter_new_password_below: "Enter new password below:"
#    change_password: "Change Password"
#    changed: "Changed"
#    available_credits: "Available Licenses"
#    pending_credits: "Pending Licenses"
#    credits: "licenses"
#    starter_licenses: "starter licenses"
#    start_date: "start date:"
#    end_date: "end date:"
#    get_enrollments_blurb: " We'll help you build a solution that meets the needs of your class, school or district."
#    how_to_apply_licenses_blurb_1: "When a teacher assigns a course to a student for the first time, we’ll automatically apply a license. Use the bulk-assign dropdown in your classroom to assign a course to selected students:"
#    how_to_apply_licenses_blurb_2: "Can I still apply a license without assigning a course?"
#    how_to_apply_licenses_blurb_3: "Yes — go to the License Status tab in your classroom and click \"Apply License\" to any student who does not have an active license."
#    request_sent: "Request Sent!"
#    license_status: "License Status"
#    status_expired: "Expired on {{date}}"
#    status_not_enrolled: "Not Enrolled"
#    status_enrolled: "Expires on {{date}}"
#    select_all: "Select All"
#    project: "Project"
#    view_student_project: "View Student Project"
#    view_arena_ladder: "View Arena Ladder"
#    resource_hub: "Resource Hub"
#    getting_started: "Getting Started"
#    educator_faq: "Educator FAQ"
#    educator_faq_desc: "Frequently asked questions about using CodeCombat in your classroom or school."
#    teacher_getting_started: "Teacher Getting Started Guide"
#    teacher_getting_started_desc: "New to CodeCombat? Download this Teacher Getting Started Guide to set up your account, create your first class, and invite students to the first course."
#    student_getting_started: "Student Quick Start Guide"
#    student_getting_started_desc: "You can distribute this guide to your students before starting CodeCombat so that they can familiarize themselves with the code editor. This guide can be used for both Python and JavaScript classrooms."
#    cs1: "Introduction to Computer Science"
#    cs2: "Computer Science 2"
#    cs3: "Computer Science 3"
#    cs4: "Computer Science 4"
#    cs5: "Computer Science 5"
#    cs1_syntax_python: "Course 1 Python Syntax Guide"
#    cs1_syntax_python_desc: "Cheatsheet with references to common Python syntax that students will learn in Introduction to Computer Science."
#    cs1_syntax_javascript: "Course 1 JavaScript Syntax Guide"
#    cs1_syntax_javascript_desc: "Cheatsheet with references to common JavaScript syntax that students will learn in Introduction to Computer Science."
#    coming_soon: "Additional guides coming soon!"
#    engineering_cycle_worksheet: "Engineering Cycle Worksheet"
#    engineering_cycle_worksheet_desc: "Use this worksheet to teach students the basics of the engineering cycle: Assess, Design, Implement and Debug. Refer to the completed example worksheet as a guide."
#    engineering_cycle_worksheet_link: "View example"
#    progress_journal: "Progress Journal"
#    progress_journal_desc: "Encourage students to keep track of their progress via a progress journal."
#    cs1_curriculum: "Introduction to Computer Science - Curriculum Guide"
#    cs1_curriculum_desc: "Scope and sequence, lesson plans, activities and more for Course 1."
#    arenas_curriculum: "Arena Levels - Teacher Guide"
#    arenas_curriculum_desc: "Instructions on how to run Wakka Maul, Cross Bones and Power Peak multiplayer arenas with your class."
#    cs2_curriculum: "Computer Science 2 - Curriculum Guide"
#    cs2_curriculum_desc: "Scope and sequence, lesson plans, activities and more for Course 2."
#    cs3_curriculum: "Computer Science 3 - Curriculum Guide"
#    cs3_curriculum_desc: "Scope and sequence, lesson plans, activities and more for Course 3."
#    cs4_curriculum: "Computer Science 4 - Curriculum Guide"
#    cs4_curriculum_desc: "Scope and sequence, lesson plans, activities and more for Course 4."
#    cs5_curriculum_js: "Computer Science 5 - Curriculum Guide (JavaScript)"
#    cs5_curriculum_desc_js: "Scope and sequence, lesson plans, activities and more for Course 5 classes using JavaScript."
#    cs5_curriculum_py: "Computer Science 5 - Curriculum Guide (Python)"
#    cs5_curriculum_desc_py: "Scope and sequence, lesson plans, activities and more for Course 5 classes using Python."
#    cs1_pairprogramming: "Pair Programming Activity"
#    cs1_pairprogramming_desc: "Introduce students to a pair programming exercise that will help them become better listeners and communicators."
#    gd1: "Game Development 1"
#    gd1_guide: "Game Development 1 - Project Guide"
#    gd1_guide_desc: "Use this to guide your students as they create their first shareable game project in 5 days."
#    wd1: "Web Development 1"
#    wd1_headlines: "Headlines & Headers Activity"
#    wd1_headlines_example: "View sample solution"
#    wd1_headlines_desc: "Why are paragraph and header tags important? Use this activity to show how well-chosen headers make web pages easier to read. There are many correct solutions to this!"
#    wd1_html_syntax: "HTML Syntax Guide"
#    wd1_html_syntax_desc: "One-page reference for the HTML style students will learn in Web Development 1."
#    wd1_css_syntax: "CSS Syntax Guide"
#    wd1_css_syntax_desc: "One-page reference for the CSS and Style syntax students will learn in Web Development 1."
#    wd2: "Web Development 2"
#    wd2_jquery_syntax: "jQuery Functions Syntax Guide"
#    wd2_jquery_syntax_desc: "One-page reference for the jQuery functions students will learn in in Web Development 2."
#    wd2_quizlet_worksheet: "Quizlet Planning Worksheet"
#    wd2_quizlet_worksheet_instructions: "View instructions & examples"
#    wd2_quizlet_worksheet_desc: "Before your students build their personality quiz project at the end of Web Development 2, they should plan out their quiz questions, outcomes and responses using this worksheet. Teachers can distribute the instructions and examples for students to refer to."
#    student_overview: "Overview"
#    student_details: "Student Details"
#    student_name: "Student Name"
#    no_name: "No name provided."
#    no_username: "No username provided."
#    no_email: "Student has no email address set."
#    student_profile: "Student Profile"
#    playtime_detail: "Playtime Detail"
#    student_completed: "Student Completed"
#    student_in_progress: "Student in Progress"
#    class_average: "Class Average"
#    not_assigned: "has not been assigned the following courses"
#    playtime_axis: "Playtime in Seconds"
#    levels_axis: "Levels in"
#    student_state: "How is"
#    student_state_2: "doing?"
#    student_good: "is doing well in"
#    student_good_detail: "This student is keeping pace with the class."
#    student_warn: "might need some help in"
#    student_warn_detail: "This student might need some help with new concepts that have been introduced in this course."
#    student_great: "is doing great in"
#    student_great_detail: "This student might be a good candidate to help other students working through this course."
#    full_license: "Full License"
#    starter_license: "Starter License"
#    trial: "Trial"
#    hoc_welcome: "Happy Computer Science Education Week"
#    hoc_intro: "There are three ways for your class to participate in Hour of Code with CodeCombat"
#    hoc_self_led: "Self-Led Gameplay"
#    hoc_self_led_desc: "Students can play through two Hour of Code CodeCombat tutorials on their own"
#    hoc_game_dev: "Game Development"
#    hoc_and: "and"
#    hoc_programming: "JavaScript/Python Programming"
#    hoc_teacher_led: "Teacher-Led Lessons"
#    hoc_teacher_led_desc1: "Download our"
#    hoc_teacher_led_link: "Introduction to Computer Science lesson plans"
#    hoc_teacher_led_desc2: "to introduce your students to programming concepts using offline activities"
#    hoc_group: "Group Gameplay"
#    hoc_group_desc_1: "Teachers can use the lessons in conjunction with our Introduction to Computer Science course to track student progress. See our"
#    hoc_group_link: "Getting Started Guide"
#    hoc_group_desc_2: "for more details"
#    hoc_additional_desc1: "For additional CodeCombat resources and activities, see our"
#    hoc_additional_desc2: "Questions"
#    hoc_additional_contact: "Get in touch"
#    revoke_confirm: "Are you sure you want to revoke a Full License from {{student_name}}? The license will become available to assign to another student."
#    revoking: "Revoking..."
#    unused_licenses: "You have unused Licenses that allow you to assign students paid courses when they're ready to learn more!"
#    remember_new_courses: "Remember to assign new courses!"
#    more_info: "More Info"
#    how_to_assign_courses: "How to Assign Courses"
#    select_students: "Select Students"
#    select_instructions: "Click the checkbox next to each student you want to assign courses to."
#    choose_course: "Choose Course"
#    choose_instructions: "Select the course from the dropdown menu you’d like to assign, then click “Assign to Selected Students.”"
#    push_projects: "We recommend assigning Web Development 1 or Game Development 1 after students have finished Introduction to Computer Science! See our {{resource_hub}} for more details on those courses."
#    teacher_quest: "Teacher's Quest for Success"
#    quests_complete: "Quests Complete"
#    teacher_quest_create_classroom: "Create Classroom"
#    teacher_quest_add_students: "Add Students"
#    teacher_quest_teach_methods: "Help your students learn how to `call methods`."
#    teacher_quest_teach_methods_step1: "Get 75% of at least one class through the first level, __Dungeons of Kithgard__"
#    teacher_quest_teach_methods_step2: "Print out the [Student Quick Start Guide](http://files.codecombat.com/docs/resources/StudentQuickStartGuide.pdf) in the Resource Hub."
#    teacher_quest_teach_strings: "Don't string your students along, teach them `strings`."
#    teacher_quest_teach_strings_step1: "Get 75% of at least one class through __True Names__"
#    teacher_quest_teach_strings_step2: "Use the Teacher Level Selector on [Course Guides](/teachers/courses) page to preview __True Names__."
#    teacher_quest_teach_loops: "Keep your students in the loop about `loops`."
#    teacher_quest_teach_loops_step1: "Get 75% of at least one class through __Fire Dancing__."
#    teacher_quest_teach_loops_step2: "Use the __Loops Activity__ in the [CS1 Curriculum guide](/teachers/resources/cs1) to reinforce this concept."
#    teacher_quest_teach_variables: "Vary it up with `variables`."
#    teacher_quest_teach_variables_step1: "Get 75% of at least one class through __Known Enemy__."
#    teacher_quest_teach_variables_step2: "Encourage collaboration by using the [Pair Programming Activity](/teachers/resources/pair-programming)."
#    teacher_quest_kithgard_gates_100: "Escape the Kithgard Gates with your class."
#    teacher_quest_kithgard_gates_100_step1: "Get 75% of at least one class through __Kithgard Gates__."
#    teacher_quest_kithgard_gates_100_step2: "Guide students to think through hard problems using the [Engineering Cycle Worksheet](http://files.codecombat.com/docs/resources/EngineeringCycleWorksheet.pdf)."
#    teacher_quest_wakka_maul_100: "Prepare to duel in Wakka Maul."
#    teacher_quest_wakka_maul_100_step1: "Get 75% of at least one class to __Wakka Maul__."
#    teacher_quest_wakka_maul_100_step2: "See the [Arena Guide](/teachers/resources/arenas) in the [Resource Hub](/teachers/resources) for tips on how to run a successful arena day."
#    teacher_quest_reach_gamedev: "Explore new worlds!"
#    teacher_quest_reach_gamedev_step1: "[Get licenses](/teachers/licenses) so that your students can explore new worlds, like Game Development and Web Development!"
#    teacher_quest_done: "Want your students to learn even more code? Get in touch with our [school specialists](mailto:schools@codecombat.com) today!"
#    teacher_quest_keep_going: "Keep going! Here's what you can do next:"
#    teacher_quest_more: "See all quests"
#    teacher_quest_less: "See fewer quests"
#    refresh_to_update: "(refresh the page to see updates)"

#  sharing:
#    game: "Game"
#    webpage: "Webpage"
#    your_students_preview: "Your students will click here to see their finished projects! Unavailable in teacher preview."
#    unavailable: "Link sharing not available in teacher preview."
#    share_game: "Share This Game"
#    share_web: "Share This Webpage"
#    victory_share_prefix: "Share this link to invite your friends & family to"
#    victory_share_game: "play your game level"
#    victory_share_web: "view your webpage"
#    victory_share_suffix: "."
#    victory_course_share_prefix: "This link will let your friends & family"
#    victory_course_share_game: "play the game"
#    victory_course_share_web: "view the webpage"
#    victory_course_share_suffix: "you just created."
#    copy_url: "Copy URL"

#  game_dev:
#    creator: "Creator"

#  web_dev:
#    image_gallery_title: "Image Gallery"
#    select_an_image: "Select an image you want to use"
#    scroll_down_for_more_images: "(Scroll down for more images)"
#    copy_the_url: "Copy the URL below"
#    copy_the_url_description: "Useful if you want to replace an existing image."
#    copy_the_img_tag: "Copy the <img> tag"
#    copy_the_img_tag_description: "Useful if you want to insert a new image."
#    copy_url: "Copy URL"
#    copy_img: "Copy <img>"
#    how_to_copy_paste: "How to Copy/Paste"
#    copy: "Copy"
#    paste: "Paste"
#    back_to_editing: "Back to Editing"

#  classes:
#    archmage_title: "Archmage"
#    archmage_title_description: "(Coder)"
#    archmage_summary: "If you are a developer interested in coding educational games, become an archmage to help us build CodeCombat!"
#    artisan_title: "Artisan"
#    artisan_title_description: "(Level Builder)"
#    artisan_summary: "Build and share levels for you and your friends to play. Become an Artisan to learn the art of teaching others to program."
#    adventurer_title: "Adventurer"
#    adventurer_title_description: "(Level Playtester)"
#    adventurer_summary: "Get our new levels (even our subscriber content) for free one week early and help us work out bugs before our public release."
#    scribe_title: "Scribe"
#    scribe_title_description: "(Article Editor)"
#    scribe_summary: "Good code needs good documentation. Write, edit, and improve the docs read by millions of players across the globe."
#    diplomat_title: "Diplomat"
#    diplomat_title_description: "(Translator)"
#    diplomat_summary: "CodeCombat is localized in 45+ languages by our Diplomats. Help us out and contribute translations."
#    ambassador_title: "Ambassador"
#    ambassador_title_description: "(Support)"
#    ambassador_summary: "Tame our forum users and provide direction for those with questions. Our ambassadors represent CodeCombat to the world."
#    teacher_title: "Teacher"

#  editor:
#    main_title: "CodeCombat Editors"
#    article_title: "Article Editor"
#    thang_title: "Thang Editor"
#    level_title: "Level Editor"
#    course_title: "Course Editor"
#    achievement_title: "Achievement Editor"
#    poll_title: "Poll Editor"
#    back: "Back"
#    revert: "Revert"
#    revert_models: "Revert Models"
#    pick_a_terrain: "Pick A Terrain"
#    dungeon: "Dungeon"
#    indoor: "Indoor"
#    desert: "Desert"
#    grassy: "Grassy"
#    mountain: "Mountain"
#    glacier: "Glacier"
#    small: "Small"
#    large: "Large"
#    fork_title: "Fork New Version"
#    fork_creating: "Creating Fork..."
#    generate_terrain: "Generate Terrain"
#    more: "More"
#    wiki: "Wiki"
#    live_chat: "Live Chat"
#    thang_main: "Main"
#    thang_spritesheets: "Spritesheets"
#    thang_colors: "Colors"
#    level_some_options: "Some Options?"
#    level_tab_thangs: "Thangs"
#    level_tab_scripts: "Scripts"
#    level_tab_components: "Components"
#    level_tab_systems: "Systems"
#    level_tab_docs: "Documentation"
#    level_tab_thangs_title: "Current Thangs"
#    level_tab_thangs_all: "All"
#    level_tab_thangs_conditions: "Starting Conditions"
#    level_tab_thangs_add: "Add Thangs"
#    level_tab_thangs_search: "Search thangs"
#    add_components: "Add Components"
#    component_configs: "Component Configurations"
#    config_thang: "Double click to configure a thang"
#    delete: "Delete"
#    duplicate: "Duplicate"
#    stop_duplicate: "Stop Duplicate"
#    rotate: "Rotate"
#    level_component_tab_title: "Current Components"
#    level_component_btn_new: "Create New Component"
#    level_systems_tab_title: "Current Systems"
#    level_systems_btn_new: "Create New System"
#    level_systems_btn_add: "Add System"
#    level_components_title: "Back to All Thangs"
#    level_components_type: "Type"
#    level_component_edit_title: "Edit Component"
#    level_component_config_schema: "Config Schema"
#    level_system_edit_title: "Edit System"
#    create_system_title: "Create New System"
#    new_component_title: "Create New Component"
#    new_component_field_system: "System"
#    new_article_title: "Create a New Article"
#    new_thang_title: "Create a New Thang Type"
#    new_level_title: "Create a New Level"
#    new_article_title_login: "Log In to Create a New Article"
#    new_thang_title_login: "Log In to Create a New Thang Type"
#    new_level_title_login: "Log In to Create a New Level"
#    new_achievement_title: "Create a New Achievement"
#    new_achievement_title_login: "Log In to Create a New Achievement"
#    new_poll_title: "Create a New Poll"
#    new_poll_title_login: "Log In to Create a New Poll"
#    article_search_title: "Search Articles Here"
#    thang_search_title: "Search Thang Types Here"
#    level_search_title: "Search Levels Here"
#    achievement_search_title: "Search Achievements"
#    poll_search_title: "Search Polls"
#    read_only_warning2: "Note: you can't save any edits here, because you're not logged in."
#    no_achievements: "No achievements have been added for this level yet."
#    achievement_query_misc: "Key achievement off of miscellanea"
#    achievement_query_goals: "Key achievement off of level goals"
#    level_completion: "Level Completion"
#    pop_i18n: "Populate I18N"
#    tasks: "Tasks"
#    clear_storage: "Clear your local changes"
#    add_system_title: "Add Systems to Level"
#    done_adding: "Done Adding"

#  article:
#    edit_btn_preview: "Preview"
#    edit_article_title: "Edit Article"

#  polls:
#    priority: "Priority"

#  contribute:
#    page_title: "Contributing"
#    intro_blurb: "CodeCombat is 100% open source! Hundreds of dedicated players have helped us build the game into what it is today. Join us and write the next chapter in CodeCombat's quest to teach the world to code!"
#    alert_account_message_intro: "Hey there!"
#    alert_account_message: "To subscribe for class emails, you'll need to be logged in first."
#    archmage_introduction: "One of the best parts about building games is they synthesize so many different things. Graphics, sound, real-time networking, social networking, and of course many of the more common aspects of programming, from low-level database management, and server administration to user facing design and interface building. There's a lot to do, and if you're an experienced programmer with a hankering to really dive into the nitty-gritty of CodeCombat, this class might be for you. We would love to have your help building the best programming game ever."
#    class_attributes: "Class Attributes"
#    archmage_attribute_1_pref: "Knowledge in "
#    archmage_attribute_1_suf: ", or a desire to learn. Most of our code is in this language. If you're a fan of Ruby or Python, you'll feel right at home. It's JavaScript, but with a nicer syntax."
#    archmage_attribute_2: "Some experience in programming and personal initiative. We'll help you get oriented, but we can't spend much time training you."
#    how_to_join: "How To Join"
#    join_desc_1: "Anyone can help out! Just check out our "
#    join_desc_2: "to get started, and check the box below to mark yourself as a brave Archmage and get the latest news by email. Want to chat about what to do or how to get more deeply involved? "
#    join_desc_3: ", or find us in our "
#    join_desc_4: "and we'll go from there!"
#    join_url_email: "Email us"
#    join_url_slack: "public Slack channel"
#    archmage_subscribe_desc: "Get emails on new coding opportunities and announcements."
#    artisan_introduction_pref: "We must construct additional levels! People be clamoring for more content, and we can only build so many ourselves. Right now your workstation is level one; our level editor is barely usable even by its creators, so be wary. If you have visions of campaigns spanning for-loops to"
#    artisan_introduction_suf: ", then this class might be for you."
#    artisan_attribute_1: "Any experience in building content like this would be nice, such as using Blizzard's level editors. But not required!"
#    artisan_attribute_2: "A hankering to do a whole lot of testing and iteration. To make good levels, you need to take it to others and watch them play it, and be prepared to find a lot of things to fix."
#    artisan_attribute_3: "For the time being, endurance en par with an Adventurer. Our Level Editor is super preliminary and frustrating to use. You have been warned!"
#    artisan_join_desc: "Use the Level Editor in these steps, give or take:"
#    artisan_join_step1: "Read the documentation."
#    artisan_join_step2: "Create a new level and explore existing levels."
#    artisan_join_step3: "Find us in our public Slack channel for help."
#    artisan_join_step4: "Post your levels on the forum for feedback."
#    artisan_subscribe_desc: "Get emails on level editor updates and announcements."
#    adventurer_introduction: "Let's be clear about your role: you are the tank. You're going to take heavy damage. We need people to try out brand-new levels and help identify how to make things better. The pain will be enormous; making good games is a long process and no one gets it right the first time. If you can endure and have a high constitution score, then this class might be for you."
#    adventurer_attribute_1: "A thirst for learning. You want to learn how to code and we want to teach you how to code. You'll probably be doing most of the teaching in this case, though."
#    adventurer_attribute_2: "Charismatic. Be gentle but articulate about what needs improving, and offer suggestions on how to improve."
#    adventurer_join_pref: "Either get together with (or recruit!) an Artisan and work with them, or check the box below to receive emails when there are new levels to test. We'll also be posting about levels to review on our networks like"
#    adventurer_forum_url: "our forum"
#    adventurer_join_suf: "so if you prefer to be notified those ways, sign up there!"
#    adventurer_subscribe_desc: "Get emails when there are new levels to test."
#    scribe_introduction_pref: "CodeCombat isn't just going to be a bunch of levels. It will also include a resource for knowledge, a wiki of programming concepts that levels can hook into. That way rather than each Artisan having to describe in detail what a comparison operator is, they can simply link their level to the Article describing them that is already written for the player's edification. Something along the lines of what the "
#    scribe_introduction_url_mozilla: "Mozilla Developer Network"
#    scribe_introduction_suf: " has built. If your idea of fun is articulating the concepts of programming in Markdown form, then this class might be for you."
#    scribe_attribute_1: "Skill in words is pretty much all you need. Not only grammar and spelling, but able to convey complicated ideas to others."
#    contact_us_url: "Contact Us"
#    scribe_join_description: "tell us a little about yourself, your experience with programming and what sort of things you'd like to write about. We'll go from there!"
#    scribe_subscribe_desc: "Get emails about article writing announcements."
#    diplomat_introduction_pref: "So, if there's one thing we learned from the "
#    diplomat_launch_url: "launch in October"
#    diplomat_introduction_suf: "it's that there is sizeable interest in CodeCombat in other countries! We're building a corps of translators eager to turn one set of words into another set of words to get CodeCombat as accessible across the world as possible. If you like getting sneak peeks at upcoming content and getting these levels to your fellow nationals ASAP, then this class might be for you."
#    diplomat_attribute_1: "Fluency in English and the language you would like to translate to. When conveying complicated ideas, it's important to have a strong grasp in both!"
#    diplomat_i18n_page_prefix: "You can start translating our levels by going to our"
#    diplomat_i18n_page: "translations page"
#    diplomat_i18n_page_suffix: ", or our interface and website on GitHub."
#    diplomat_join_pref_github: "Find your language locale file "
#    diplomat_github_url: "on GitHub"
#    diplomat_join_suf_github: ", edit it online, and submit a pull request. Also, check this box below to keep up-to-date on new internationalization developments!"
#    diplomat_subscribe_desc: "Get emails about i18n developments and levels to translate."
#    ambassador_introduction: "This is a community we're building, and you are the connections. We've got forums, emails, and social networks with lots of people to talk with and help get acquainted with the game and learn from. If you want to help people get involved and have fun, and get a good feel of the pulse of CodeCombat and where we're going, then this class might be for you."
#    ambassador_attribute_1: "Communication skills. Be able to identify the problems players are having and help them solve them. Also, keep the rest of us informed about what players are saying, what they like and don't like and want more of!"
#    ambassador_join_desc: "tell us a little about yourself, what you've done and what you'd be interested in doing. We'll go from there!"
#    ambassador_join_note_strong: "Note"
#    ambassador_join_note_desc: "One of our top priorities is to build multiplayer where players having difficulty solving levels can summon higher level wizards to help them. This will be a great way for ambassadors to do their thing. We'll keep you posted!"
#    ambassador_subscribe_desc: "Get emails on support updates and multiplayer developments."
#    teacher_subscribe_desc: "Get emails on updates and announcements for teachers."
#    changes_auto_save: "Changes are saved automatically when you toggle checkboxes."
#    diligent_scribes: "Our Diligent Scribes:"
#    powerful_archmages: "Our Powerful Archmages:"
#    creative_artisans: "Our Creative Artisans:"
#    brave_adventurers: "Our Brave Adventurers:"
#    translating_diplomats: "Our Translating Diplomats:"
#    helpful_ambassadors: "Our Helpful Ambassadors:"

#  ladder:
#    my_matches: "My Matches"
#    simulate: "Simulate"
#    simulation_explanation: "By simulating games you can get your game ranked faster!"
#    simulation_explanation_leagues: "You will mainly help simulate games for allied players in your clans and courses."
#    simulate_games: "Simulate Games!"
#    games_simulated_by: "Games simulated by you:"
#    games_simulated_for: "Games simulated for you:"
#    games_in_queue: "Games currently in the queue:"
#    games_simulated: "Games simulated"
#    games_played: "Games played"
#    ratio: "Ratio"
#    leaderboard: "Leaderboard"
#    battle_as: "Battle as "
#    summary_your: "Your "
#    summary_matches: "Matches - "
#    summary_wins: " Wins, "
#    summary_losses: " Losses"
#    rank_no_code: "No New Code to Rank"
#    rank_my_game: "Rank My Game!"
#    rank_submitting: "Submitting..."
#    rank_submitted: "Submitted for Ranking"
#    rank_failed: "Failed to Rank"
#    rank_being_ranked: "Game Being Ranked"
#    rank_last_submitted: "submitted "
#    help_simulate: "Help simulate games?"
#    code_being_simulated: "Your new code is being simulated by other players for ranking. This will refresh as new matches come in."
#    no_ranked_matches_pre: "No ranked matches for the "
#    no_ranked_matches_post: " team! Play against some competitors and then come back here to get your game ranked."
#    choose_opponent: "Choose an Opponent"
#    select_your_language: "Select your language!"
#    tutorial_play: "Play Tutorial"
#    tutorial_recommended: "Recommended if you've never played before"
#    tutorial_skip: "Skip Tutorial"
#    tutorial_not_sure: "Not sure what's going on?"
#    tutorial_play_first: "Play the Tutorial first."
#    simple_ai: "Simple CPU"
#    warmup: "Warmup"
#    friends_playing: "Friends Playing"
#    log_in_for_friends: "Log in to play with your friends!"
#    social_connect_blurb: "Connect and play against your friends!"
#    invite_friends_to_battle: "Invite your friends to join you in battle!"
#    fight: "Fight!"
#    watch_victory: "Watch your victory"
#    defeat_the: "Defeat the"
#    watch_battle: "Watch the battle"
#    tournament_started: ", started"
#    tournament_ends: "Tournament ends"
#    tournament_ended: "Tournament ended"
#    tournament_rules: "Tournament Rules"
#    tournament_blurb: "Write code, collect gold, build armies, crush foes, win prizes, and upgrade your career in our $40,000 Greed tournament! Check out the details"
#    tournament_blurb_criss_cross: "Win bids, construct paths, outwit opponents, grab gems, and upgrade your career in our Criss-Cross tournament! Check out the details"
#    tournament_blurb_zero_sum: "Unleash your coding creativity in both gold gathering and battle tactics in this alpine mirror match between red sorcerer and blue sorcerer. The tournament began on Friday, March 27 and will run until Monday, April 6 at 5PM PDT. Compete for fun and glory! Check out the details"
#    tournament_blurb_ace_of_coders: "Battle it out in the frozen glacier in this domination-style mirror match! The tournament began on Wednesday, September 16 and will run until Wednesday, October 14 at 5PM PDT. Check out the details"
#    tournament_blurb_blog: "on our blog"
#    rules: "Rules"
#    winners: "Winners"
#    league: "League"
#    red_ai: "Red CPU" # "Red AI Wins", at end of multiplayer match playback
#    blue_ai: "Blue CPU"
#    wins: "Wins" # At end of multiplayer match playback
#    humans: "Red" # Ladder page display team name
#    ogres: "Blue"

#  user:
#    stats: "Stats"
#    singleplayer_title: "Singleplayer Levels"
#    multiplayer_title: "Multiplayer Levels"
#    achievements_title: "Achievements"
#    last_played: "Last Played"
#    status: "Status"
#    status_completed: "Completed"
#    status_unfinished: "Unfinished"
#    no_singleplayer: "No Singleplayer games played yet."
#    no_multiplayer: "No Multiplayer games played yet."
#    no_achievements: "No Achievements earned yet."
#    favorite_prefix: "Favorite language is "
#    favorite_postfix: "."
#    not_member_of_clans: "Not a member of any clans yet."

#  achievements:
#    last_earned: "Last Earned"
#    amount_achieved: "Amount"
#    achievement: "Achievement"
#    current_xp_prefix: ""
#    current_xp_postfix: " in total"
#    new_xp_prefix: ""
#    new_xp_postfix: " earned"
#    left_xp_prefix: ""
#    left_xp_infix: " until level "
#    left_xp_postfix: ""

#  account:
#    payments: "Payments"
#    prepaid_codes: "Prepaid Codes"
#    purchased: "Purchased"
#    subscription: "Subscription"
#    invoices: "Invoices"
#    service_apple: "Apple"
#    service_web: "Web"
#    paid_on: "Paid On"
#    service: "Service"
#    price: "Price"
#    gems: "Gems"
#    active: "Active"
#    subscribed: "Subscribed"
#    unsubscribed: "Unsubscribed"
#    active_until: "Active Until"
#    cost: "Cost"
#    next_payment: "Next Payment"
#    card: "Card"
#    status_unsubscribed_active: "You're not subscribed and won't be billed, but your account is still active for now."
#    status_unsubscribed: "Get access to new levels, heroes, items, and bonus gems with a CodeCombat subscription!"
#    not_yet_verified: "Not yet verified."
#    resend_email: "Resend email"
#    email_sent: "Email sent! Check your inbox."
#    verifying_email: "Verifying your email address..."
#    successfully_verified: "You've successfully verified your email address!"
#    verify_error: "Something went wrong when verifying your email :("

#  account_invoices:
#    amount: "Amount in US dollars"
#    declined: "Your card was declined"
#    invalid_amount: "Please enter a US dollar amount."
#    not_logged_in: "Log in or create an account to access invoices."
#    pay: "Pay Invoice"
#    purchasing: "Purchasing..."
#    retrying: "Server error, retrying."
#    success: "Successfully paid. Thanks!"

#  account_prepaid:
#    purchase_code: "Purchase a Subscription Code"
#    purchase_code1: "Subscription Codes can be redeemed to add premium subscription time to one or more accounts for the Home version of CodeCombat." #
#    purchase_code2: "Each CodeCombat account can only redeem a particular Subscription Code once."
#    purchase_code3: "Subscription Code months will be added to the end of any existing subscription on the account."
#    purchase_code4: "Subscription Codes are for accounts playing the Home version of CodeCombat, they cannot be used in place of Student Licenses for the Classroom version."
#    purchase_code5: "For more information on Student Licenses, reach out to"
#    users: "Users"
#    months: "Months"
#    purchase_total: "Total"
#    purchase_button: "Submit Purchase"
#    your_codes: "Your Codes"
#    redeem_codes: "Redeem a Subscription Code"
#    prepaid_code: "Prepaid Code"
#    lookup_code: "Lookup prepaid code"
#    apply_account: "Apply to your account"
#    copy_link: "You can copy the code's link and send it to someone."
#    quantity: "Quantity"
#    redeemed: "Redeemed"
#    no_codes: "No codes yet!"
#    you_can1: "You can"
#    you_can2: "purchase a prepaid code"
#    you_can3: "that can be applied to your own account or given to others."

#  loading_error:
#    could_not_load: "Error loading from server"
#    connection_failure: "Connection Failed"
#    connection_failure_desc: "It doesn’t look like you’re connected to the internet! Check your network connection and then reload this page."
#    login_required: "Login Required"
#    login_required_desc: "You need to be logged in to access this page."
#    unauthorized: "You need to be signed in. Do you have cookies disabled?"
#    forbidden: "Forbidden"
#    forbidden_desc: "Oh no, there’s nothing we can show you here! Make sure you’re logged into the correct account, or visit one of the links below to get back to programming!"
#    not_found: "Not Found"
#    not_found_desc: "Hm, there’s nothing here. Visit one of the following links to get back to programming!"
#    not_allowed: "Method not allowed."
#    timeout: "Server Timeout"
#    conflict: "Resource conflict."
#    bad_input: "Bad input."
#    server_error: "Server error."
#    unknown: "Unknown Error"
#    error: "ERROR"
#    general_desc: "Something went wrong, and it’s probably our fault. Try waiting a bit and then refreshing the page, or visit one of the following links to get back to programming!"

#  resources:
#    level: "Level"
#    patch: "Patch"
#    patches: "Patches"
#    system: "System"
#    systems: "Systems"
#    component: "Component"
#    components: "Components"
#    hero: "Hero"
#    campaigns: "Campaigns"

#  concepts:
#    advanced_css_rules: "Advanced CSS Rules"
#    advanced_css_selectors: "Advanced CSS Selectors"
#    advanced_html_attributes: "Advanced HTML Attributes"
#    advanced_html_tags: "Advanced HTML Tags"
#    algorithm_average: "Algorithm Average"
#    algorithm_find_minmax: "Algorithm Find Min/Max"
#    algorithm_search_binary: "Algorithm Search Binary"
#    algorithm_search_graph: "Algorithm Search Graph"
#    algorithm_sort: "Algorithm Sort"
#    algorithm_sum: "Algorithm Sum"
#    arguments: "Arguments"
#    arithmetic: "Arithmetic"
#    array_2d: "2D Array"
#    array_index: "Array Indexing"
#    array_iterating: "Iterating Over Arrays"
#    array_literals: "Array Literals"
#    array_searching: "Array Searching"
#    array_sorting: "Array Sorting"
#    arrays: "Arrays"
#    basic_css_rules: "Basic CSS rules"
#    basic_css_selectors: "Basic CSS selectors"
#    basic_html_attributes: "Basic HTML Attributes"
#    basic_html_tags: "Basic HTML Tags"
#    basic_syntax: "Basic Syntax"
#    binary: "Binary"
#    boolean_and: "Boolean And"
#    boolean_equality: "Boolean Equality"
#    boolean_greater_less: "Boolean Greater/Less"
#    boolean_logic_shortcircuit: "Boolean Logic Shortcircuiting"
#    boolean_not: "Boolean Not"
#    boolean_operator_precedence: "Boolean Operator Precedence"
#    boolean_or: "Boolean Or"
#    bootstrap: "Bootstrap"
#    break_statements: "Break Statements"
#    classes: "Classes"
#    continue_statements: "Continue Statements"
#    dom_events: "DOM Events"
#    dynamic_styling: "Dynamic Styling"
#    event_concurrency: "Event Concurrency"
#    event_data: "Event Data"
#    event_handlers: "Event Handlers"
#    for_loops: "For Loops"
#    for_loops_nested: "Nested For Loops"
#    for_loops_range: "For Loops Range"
#    functions: "Functions"
#    game_ai: "Game AI"
#    game_goals: "Game Goals"
#    game_spawn: "Game Spawn"
#    graphics: "Graphics"
#    graphs: "Graphs"
#    heaps: "Heaps"
#    if_else_statements: "If/Else Statements"
#    if_statements: "If Statements"
#    if_statements_nested: "Nested If Statemnts"
#    indexing: "Array Indexes"
#    input_handling_flags: "Input Handling - Flags"
#    input_handling_keyboard: "Input Handling - Keyboard"
#    input_handling_mouse: "Input Handling - Mouse"
#    intermediate_css_rules: "Intermediate CSS Rules"
#    intermediate_css_selectors: "Intermediate CSS Selectors"
#    intermediate_html_attributes: "Intermediate HTML Attributes"
#    intermediate_html_tags: "Intermediate HTML Tags"
#    jquery: "jQuery"
#    jquery_animations: "jQuery Animations"
#    jquery_filtering: "jQuery Element Filtering"
#    jquery_selectors: "jQuery Selectors"
#    length: "Array Length"
#    math_geometry: "Geometry"
#    math_operations: "Math Library Operations"
#    math_trigonometry: "Trigonometry"
#    object_literals: "Object Literals"
#    parameters: "Parameters"
#    property_access: "Accessing Properties"
#    property_assignment: "Assigning Properties"
#    queues: "Data Structures - Queues"
#    reading_docs: "Reading the Docs"
#    recursion: "Recursion"
#    return_statements: "Return Statements"
#    stacks: "Data Structures - Stacks"
#    strings: "Strings"
#    strings_concatenation: "String Concatenation"
#    strings_substrings: "Substring"
#    trees: "Data Structures - Trees"
#    variables: "Variables"
#    vectors: "Vectors"
#    while_condition_loops: "While Loops with Conditionals"
#    while_loops_simple: "While Loops"
#    while_loops_nested: "Nested While Loops"
#    xy_coordinates: "Cartesian Coordinates"
#    advanced_strings: "Advanced Strings" # Rest of concepts are deprecated
#    algorithms: "Algorithms"
#    boolean_logic: "Boolean Logic"
#    basic_html: "Basic HTML"
#    basic_css: "Basic CSS"
#    basic_web_scripting: "Basic Web Scripting"
#    intermediate_html: "Intermediate HTML"
#    intermediate_css: "Intermediate CSS"
#    intermediate_web_scripting: "Intermediate Web Scripting"
#    advanced_html: "Advanced HTML"
#    advanced_css: "Advanced CSS"
#    advanced_web_scripting: "Advanced Web Scripting"
#    input_handling: "Input Handling"
#    while_loops: "While Loops"
#    place_game_objects: "Place game objects"
#    construct_mazes: "Construct mazes"
#    create_playable_game: "Create a playable, sharable game project"
#    alter_existing_web_pages: "Alter existing web pages"
#    create_sharable_web_page: "Create a sharable web page"
#    basic_input_handling: "Basic Input Handling"
#    basic_game_ai: "Basic Game AI"
#    basic_javascript: "Basic JavaScript"
#    basic_event_handling: "Basic Event Handling"
#    create_sharable_interactive_web_page: "Create a sharable interactive web page"

#  delta:
#    added: "Added"
#    modified: "Modified"
#    not_modified: "Not Modified"
#    deleted: "Deleted"
#    moved_index: "Moved Index"
#    text_diff: "Text Diff"
#    merge_conflict_with: "MERGE CONFLICT WITH"
#    no_changes: "No Changes"

#  legal:
#    page_title: "Legal"
#    opensource_intro: "CodeCombat is completely open source."
#    opensource_description_prefix: "Check out "
#    github_url: "our GitHub"
#    opensource_description_center: "and help out if you like! CodeCombat is built on dozens of open source projects, and we love them. See "
#    archmage_wiki_url: "our Archmage wiki"
#    opensource_description_suffix: "for a list of the software that makes this game possible."
#    practices_title: "Respectful Best Practices"
#    practices_description: "These are our promises to you, the player, in slightly less legalese."
#    privacy_title: "Privacy"
#    privacy_description: "We will not sell any of your personal information."
#    security_title: "Security"
#    security_description: "We strive to keep your personal information safe. As an open source project, our site is freely open to anyone to review and improve our security systems."
#    email_title: "Email"
#    email_description_prefix: "We will not inundate you with spam. Through"
#    email_settings_url: "your email settings"
#    email_description_suffix: "or through links in the emails we send, you can change your preferences and easily unsubscribe at any time."
#    cost_title: "Cost"
#    cost_description: "CodeCombat is free to play for all of its core levels, with a ${{price}} USD/mo subscription for access to extra level branches and {{gems}} bonus gems per month. You can cancel with a click, and we offer a 100% money-back guarantee."
#    copyrights_title: "Copyrights and Licenses"
#    contributor_title: "Contributor License Agreement"
#    contributor_description_prefix: "All contributions, both on the site and on our GitHub repository, are subject to our"
#    cla_url: "CLA"
#    contributor_description_suffix: "to which you should agree before contributing."
#    code_title: "Code - MIT"
#    code_description_prefix: "All code owned by CodeCombat or hosted on codecombat.com, both in the GitHub repository or in the codecombat.com database, is licensed under the"
#    mit_license_url: "MIT license"
#    code_description_suffix: "This includes all code in Systems and Components that are made available by CodeCombat for the purpose of creating levels."
#    art_title: "Art/Music - Creative Commons "
#    art_description_prefix: "All common content is available under the"
#    cc_license_url: "Creative Commons Attribution 4.0 International License"
#    art_description_suffix: "Common content is anything made generally available by CodeCombat for the purpose of creating Levels. This includes:"
#    art_music: "Music"
#    art_sound: "Sound"
#    art_artwork: "Artwork"
#    art_sprites: "Sprites"
#    art_other: "Any and all other non-code creative works that are made available when creating Levels."
#    art_access: "Currently there is no universal, easy system for fetching these assets. In general, fetch them from the URLs as used by the site, contact us for assistance, or help us in extending the site to make these assets more easily accessible."
#    art_paragraph_1: "For attribution, please name and link to codecombat.com near where the source is used or where appropriate for the medium. For example:"
#    use_list_1: "If used in a movie or another game, include codecombat.com in the credits."
#    use_list_2: "If used on a website, include a link near the usage, for example underneath an image, or in a general attributions page where you might also mention other Creative Commons works and open source software being used on the site. Something that's already clearly referencing CodeCombat, such as a blog post mentioning CodeCombat, does not need some separate attribution."
#    art_paragraph_2: "If the content being used is created not by CodeCombat but instead by a user of codecombat.com, attribute them instead, and follow attribution directions provided in that resource's description if there are any."
#    rights_title: "Rights Reserved"
#    rights_desc: "All rights are reserved for Levels themselves. This includes"
#    rights_scripts: "Scripts"
#    rights_unit: "Unit configuration"
#    rights_writings: "Writings"
#    rights_media: "Media (sounds, music) and any other creative content made specifically for that Level and not made generally available when creating Levels."
#    rights_clarification: "To clarify, anything that is made available in the Level Editor for the purpose of making levels is under CC, whereas the content created with the Level Editor or uploaded in the course of creation of Levels is not."
#    nutshell_title: "In a Nutshell"
#    nutshell_description: "Any resources we provide in the Level Editor are free to use as you like for creating Levels. But we reserve the right to restrict distribution of the Levels themselves (that are created on codecombat.com) so that they may be charged for."
#    canonical: "The English version of this document is the definitive, canonical version. If there are any discrepancies between translations, the English document takes precedence."
#    third_party_title: "Third Party Services"
#    third_party_description: "CodeCombat uses the following third party services (among others):"

#  ladder_prizes:
#    title: "Tournament Prizes" # This section was for an old tournament and doesn't need new translations now.
#    blurb_1: "These prizes will be awarded according to"
#    blurb_2: "the tournament rules"
#    blurb_3: "to the top human and ogre players."
#    blurb_4: "Two teams means double the prizes!"
#    blurb_5: "(There will be two first place winners, two second-place winners, etc.)"
#    rank: "Rank"
#    prizes: "Prizes"
#    total_value: "Total Value"
#    in_cash: "in cash"
#    custom_wizard: "Custom CodeCombat Wizard"
#    custom_avatar: "Custom CodeCombat avatar"
#    heap: "for six months of \"Startup\" access"
#    credits: "credits"
#    one_month_coupon: "coupon: choose either Rails or HTML"
#    one_month_discount: "discount, 30% off: choose either Rails or HTML"
#    license: "license"
#    oreilly: "ebook of your choice"

#  calendar:
#    year: "Year"
#    day: "Day"
#    month: "Month"
#    january: "January"
#    february: "February"
#    march: "March"
#    april: "April"
#    may: "May"
#    june: "June"
#    july: "July"
#    august: "August"
#    september: "September"
#    october: "October"
#    november: "November"
#    december: "December"

#  code_play_create_account_modal:
#    title: "You did it!" # This section is only needed in US, UK, Mexico, India, and Germany
#    body: "You are now on your way to becoming a master coder. Sign up to receive an extra <strong>100 Gems</strong> & you will also be entered for a chance to <strong>win $2,500 & other Lenovo Prizes</strong>."
#    sign_up: "Sign up & keep coding ▶"
#    victory_sign_up_poke: "Create a free account to save your code & be entered for a chance to win prizes!"
#    victory_sign_up: "Sign up & be entered to <strong>win $2,500</strong>"

#  server_error:
#    email_taken: "Email already taken"
#    username_taken: "Username already taken"

#  esper:
#    line_no: "Line $1: "
#    x_not_a_function: "`$1` is not a function"
#    type_error: "TypeError: "
#    reference_error: "ReferenceError: "
#    spelling_issues: "Look out for spelling issues: did you mean `$1` instead of `$2`?"
#    capitalization_issues: "Look out for capitalization: `$1` should be `$2`."
#    py_empty_block: "Empty $1. Put 4 spaces in front of statements inside the $2."
#    fx_missing_paren: "If you want to call `$1` as function, you need `()`'s"
#    unmatched_token: "Unmatched `$1`.  Every opening `$2` needs a closing `$3` to match it."
#    unterminated_string: "Unterminated string. Add a matching `\"` at the end of your string."
